<template>
    <div class="animated fadeIn">
      <b-row>
        <b-col sm="12">
          <b-card>
  
            <b-row class="mb-4">
              <input type="hidden" name="isactiveId" id="isactiveId" value="" />
              <input
                type="hidden"
                name="deliveryagentmasterId"
                id="deliveryagentmasterId"
                value=""
              />
  
              <b-col md="7" class="my-1">
                <b-row>
                  <b-col>
                    <b-form-group label-cols-sm="3" label="Filter" class="mb-0">
                      <b-input-group>
                        <b-form-input
                          v-model="vehiclefilter"
                          placeholder="Vehicle No or Id/Transporter Name to search"
                        ></b-form-input>
                      </b-input-group>
                    </b-form-group>
                  </b-col>
                  <b-col>
                    <b-button
                      @click="searchInLoadManagement()"
                      size="md"
                      variant="primary"
                      >Search</b-button
                    >
                    &nbsp;
                    <b-button @click="clearSearch()" size="md" variant="danger"
                      >Clear</b-button
                    > 
                  </b-col>
                </b-row>
              </b-col>
  
              <b-col md="4" class="my-1">
                <b-form-group label-cols-sm="2" label="Sort" class="mb-0">
                  <b-input-group>
                    <b-form-select v-model="sortBy" :options="sortOptions">
                      <option slot="first" :value="null">-- none --</option>
                    </b-form-select>
                    <b-form-select
                      v-model="sortDesc"
                      :disabled="!sortBy"
                      slot="append"
                    >
                      <option :value="false">Asc</option>
                      <option :value="true">Desc</option>
                    </b-form-select>
                  </b-input-group>
                </b-form-group>
              </b-col>
            </b-row>
            <b-row>
              <b-col sm="4">   
                  <b-form-group label-cols-sm="4" label="Approval Level:" class="mb-0">
                    <b-form-select v-model="selectedApprovalLevel" @change="handleFilterChange">
                      <option value="">All Levels</option>
                      <option value="1">L1</option>
                      <option value="2">L2</option>
                      <option value="3">L3</option>
                    </b-form-select>
                  </b-form-group>
              </b-col>
              <b-col sm="4" class="text-right">
                <p>
                  <b>Total Records:<span style="color:red;">{{totalRows}}</span></b>
                </p>
              </b-col>

              <b-col md="4" class="text-right">
                <b-button v-if="totalRows>0" @click="downloadvehiclereport()" size="md" variant="primary">
                  Download
                </b-button>&nbsp;
                <b-button variant="success" @click="availablevehiclelist()"><i class="fa fa-check" aria-hidden="true"></i>
                  Available Vehicle
                </b-button>
              </b-col>
            </b-row>
            <br>
            
  
            <b-col sm="12">
              <b-table
                show-empty
                responsive
                :busy="isBusy"
                :items="items"
                :fields="fields"
                :current-page="currentPage"
                :bordered="bordered"
                :sort-by.sync="sortBy"
                :sort-desc.sync="sortDesc"
                :sort-direction="sortDirection"
              >
                <div slot="table-busy" class="text-center text-danger my-2">
                  <b-spinner class="align-middle"></b-spinner>
                  <strong>Loading...</strong>
                </div>
                
                <template slot="drivername" slot-scope="row">
                  <span
                    >{{ row.item.driverfirstname }}
                    {{ row.item.driverlastname }}</span
                  >
                </template>
                <template slot="vehicle_no" slot-scope="row">
                  <!-- <span> {{ row.item.vehicle_no }} </span> -->
                  <b-button :disabled="isReadOnly"
                    size="sm"
                    @click="editinfoModal(row.item)"
                    data-toggle="tooltip"
                    title="Update Vehicle Details"
                  >
                  {{ row.item.vehicle_no }}
                  </b-button>
                </template>
                <template slot="vehicle_origin" slot-scope="row">
                  <span> {{ row.item.vehicle_origin }} </span>
                </template>
                <template slot="transportername" slot-scope="row">
                  <span> {{ row.item.transporter_name }} </span>
                </template>
                  <template slot="paymenttype" slot-scope="row">
                  <span> {{ row.item.paymenttype }} </span>
                </template>
                
                
                 <template slot="vehicle_origin_city" slot-scope="row">
                  <!-- <span> {{ row.item. }}</span> -->
                  <span v-if="row.item.vehicle_origin_city != null" :title="row.item.vehicle_origin_city">
                          {{ row.item.vehicle_origin_city.substring(0, 30) + ".." }}</span>
                </template>
                <template slot="transporter_name" slot-scope="row">
                  <span> {{ row.item.transporter_name }}</span>
                </template>
                <template slot="isactive" slot-scope="row">
                  <span
                    @click="!isReadOnly && toggleInfoModal(row.item)"
                    style="cursor:pointer;"
                  >
                    <span
                      data-toggle="tooltip"
                      title="InActive"
                      v-if="row.item.isactive === '0'"
                    >
                      <span class="badge badge-danger" :class="{ 'disabled': isReadOnly }" >Inactive</span>
                    </span>
                    <span data-toggle="tooltip" title="Active" v-else>
                      <span class="badge badge-success" :class="{ 'disabled': isReadOnly }" >Active</span>
                    </span>
                  </span>
                </template>
                <template slot="createddate" slot-scope="row">
                  <div>
                      {{ row.item.createddate | ConvertTime12hour() }}
                  </div>
              </template>
                

              <template slot="invoice_status" slot-scope="row">
                <!-- freight_pending -->
                            {{row.item.nextreviewer=='1' && row.item.approver_status=='freight_pending'?'L1 Pending':
                            
                            row.item.nextreviewer=='1' && row.item.approver_status=='approved'?'L1 Approved':
                            
                            row.item.nextreviewer=='2' && row.item.approver_status=='freight_pending'?'L1 Approved':

                            row.item.nextreviewer=='2' && row.item.approver_status=='approved'?'L2 Approved':

                            row.item.nextreviewer=='3' && row.item.approver_status=='freight_pending'?'L2 Approved':

                            row.item.nextreviewer=='3' && row.item.approver_status=='approved'?'Approved':''}}
                </template>

                <template slot="actions" slot-scope="row">

                            <!-- v-if="(row.item.nextreviewer=='1' && approvedLevel=='l1' && row.item.approver_status=='pending') || (row.item.nextreviewer=='2' && approvedLevel=='l2' && row.item.approver_status=='pending') || (row.item.nextreviewer=='3' && approvedLevel=='l3' &&  row.item.approver_status=='pending')" -->
                            <b-button size="sm" @click="updateModal(row.item)" title="Success" variant="success" class="custom-open-modal" :disabled="isReadOnly"  v-if="(row.item.nextreviewer=='1' && approvedLevel=='l1' && row.item.approver_status=='freight_pending') || (row.item.nextreviewer=='2' && approvedLevel=='l2' && row.item.approver_status=='freight_pending') || (row.item.nextreviewer=='3' && approvedLevel=='l3' &&  row.item.approver_status=='freight_pending')">
                              <i class="fa fa-check" aria-hidden="true"></i>
                            </b-button>
                            &nbsp; <!-- This adds a small space between the buttons -->
                            <b-button size="sm" @click="RejectModal(row.item)" title="Reject" variant="danger" class="custom-close-modal" :disabled="isReadOnly"  v-if="(row.item.nextreviewer=='2' && approvedLevel=='l2' && row.item.approver_status=='freight_pending') || (row.item.nextreviewer=='3' && approvedLevel=='l3' &&  row.item.approver_status=='freight_pending')">
                              <i class="fa fa-times" aria-hidden="true"></i>
                            </b-button>
                            <b-button variant="primary"  class="custom-submit" size="sm" @click="transporterMasterLog(row.item.transporter_id,row.item.vehicle_id)">Log</b-button>

                </template>

                <!-- <template slot="actions" slot-scope="row">
                <b-button :disabled="isReadOnly" size="sm" @click="updateModal(row.item)" title="Success" variant="success" class="custom-open-modal">
                  <i class="fa fa-check" aria-hidden="true"></i>
                </b-button>
                &nbsp;
                <b-button :disabled="isReadOnly" size="sm" @click="RejectModal(row.item)" title="Failure" variant="danger" class="custom-close-modal">
                  <i class="fa fa-times" aria-hidden="true"></i>
                </b-button>

              </template> -->

              </b-table>
            </b-col>
  
          </b-card>
          <div>
            <!-- Pagination -->
            <b-pagination
              v-if="totalCount > perPage"
              v-model="currentPage"
              :total-rows="totalCount"
              :per-page="perPage"
              @change="displaydata"
            ></b-pagination>
          </div>
        </b-col>
      </b-row>
  
      <!-- Confirmation Box -->
      <b-modal title="Confirmation Box" v-model="toggleInfo" size="md"  @ok="toggleInfo =false">
        <template slot="modal-header" slot-scope="{ close }">
          <h5>Confirmation Box</h5>
        </template>
        <template slot="default" slot-scope="{ hide }">
          <form v-on:submit.prevent="activateInActivateDeliveryAgent(value)">
            <div class="modal-background"></div>
            <div class="modal-card">
              <section class="modal-card-body">
                <input
                  type="hidden"
                  v-model="customer.isactive"
                  name="isactive"
                  id="modalIsActiveChk"
                />
                <span>Are you sure you want to change the status?</span>
              </section>
              <footer>
                <b-button variant="primary" size="sm" type="submit" v-if="HideAnyAction!='Yes'">Ok</b-button>
              </footer>
            </div>
          </form>
        </template>
        <template slot="modal-footer" slot-scope="{ cancel }">
          <!-- Emulate built in modal footer ok and cancel button actions -->
          <b-button size="sm" variant="danger" @click="cancel()">
            Cancel
          </b-button>
        </template>
      </b-modal>
  
      <!-- Update Vehicle Details -->
      <b-modal size="xl" title="Update Vehicle Details" v-model="editAgentMaster" @ok="editAgentMaster = false" hide-footer>
          <template slot="default" slot-scope="{ hide }">

             <b-form @submit.prevent="validateForm5('form-5')" data-vv-scope="form-5">
                <h6 style="text-align:center"><b>Update Vehicle Info</b></h6>
                <br />
                <b-row>
                    <b-col sm="4" v-if="userType == 1">
                      <b-form-group>
                          <b-row>
                            <b-col sm="4" class="pr-0 d-flex">
                                <label for="hub_name"><b>Select Hub</b></label>&nbsp;<span style="color: red;">*</span>
                            </b-col>
                            <b-col sm="8" class="pl-0">
                                <v-select v-model="adminHub" :options="optionHubid" placeholder="-- Select Hub --" name="hub_name" v-validate="'required|'"
                                  :class="{
                                  input: true,
                                  'is-invalid': errors.has('form-5.hub_name'),
                                  }"></v-select>
                                <b-input-group class="mb-3">
                                  <span
                                      style="width:240px"
                                      v-show="errors.has('form-5.hub_name')"
                                      class="help text-danger"
                                      >{{errors.first("form-5.hub_name")}}</span
                                      >
                                </b-input-group>
                            </b-col>
                          </b-row>
                      </b-form-group>
                    </b-col>
                    <b-col sm="4">
                      <b-row>
                          <b-col sm="4" class="pr-0">
                            <div class="d-flex">  
                                <label><b>Vehicle Name</b></label>&nbsp;<span style="color: red;">*</span>
                            </div>
                          </b-col>
                          <b-col sm="8" class="pl-0">
                            <b-form-group>
                                <v-select v-model="customer.vehiclename" name="vehicle_name" :options="vehicleNameOptions" @input="addVehicleName" placeholder="-- Select Vehicle Name --" v-validate="'required'" :class="{
                                  input: true,
                                  'is-invalid': errors.has('form-5.vehicle_name'),
                                  }"></v-select>
                                <b-input-group class="mb-3">
                                  <span style="width:240px" v-show="errors.has('form-5.vehicle_name')" class="help text-danger">{{
                                  errors.first("form-5.vehicle_name")
                                  }}</span>
                                </b-input-group>
                            </b-form-group>
                          </b-col>
                      </b-row>
                    </b-col>
                    <b-col sm="4" v-if="vehiclenametext">
                      <b-row>
                          <b-col sm="4" class="pr-0">
                            <div class="d-flex">  
                                <label><b>Vehicle Name</b></label>&nbsp;<span style="color: red;">*</span>
                            </div>
                          </b-col>
                          <b-col sm="8" class="pl-0">
                            <b-form-group>
                                <b-form-input type="text" name="vehicle name" v-model="customer.vehiclenametext" v-validate="'required|min:3|max:30'" :class="{
                                  input: true,
                                  'is-invalid': errors.has('form-5.vehicle name'),
                                  }" placeholder="Enter Vehicle Name">
                                </b-form-input>
                                <b-input-group class="mb-3">
                                  <span class="icon has-text-warning">
                                  <i
                                      class="fa fa-warning"
                                      v-show="errors.has('vehicle name')"
                                      ></i>
                                  </span>
                                  <span style="width:240px" v-show="errors.has('form-5.vehicle name')" class="help text-danger">{{ errors.first("form-5.vehicle name") }}</span>
                                </b-input-group>
                            </b-form-group>
                          </b-col>
                      </b-row>
                    </b-col>
                    <b-col sm="4">
                      <b-row>
                          <b-col sm="5" class="pr-0">
                            <div class="d-flex">  
                                <label><b>Vehicle Number</b></label>&nbsp;<span style="color: red;">*</span>
                            </div>
                          </b-col>
                          <b-col sm="7" class="pl-0">
                            <b-form-group>
                                <b-form-input class="input" type="text" v-model="customer.editvehicleno" name="vehicleno" disabled placeholder="Enter Vehicle Number">
                                </b-form-input>
                            </b-form-group>
                          </b-col>
                      </b-row>
                    </b-col>
                    <b-col sm="4">
                      <b-row>
                          <b-col sm="5" class="pr-0">
                            <div class="d-flex">  
                                <label><b>Registration No</b></label>&nbsp;<span style="color: red;">*</span>
                            </div>
                          </b-col>
                          <b-col sm="7" class="pl-0">
                            <b-form-group>
                                <b-form-input type="text" name="registration_no" v-model="customer.registration_no" v-validate="'required'" :class="{
                                  input: true,
                                  'is-invalid': errors.has('form-5.registration_no'),
                                  }" placeholder="Enter Registration Certificate No">
                                </b-form-input>
                                <span style="width:100px" v-show="errors.has('form-5.registration_no')" class="help text-danger">{{ errors.first("form-5.registration_no") }}</span
                                  >
                            </b-form-group>
                          </b-col>
                      </b-row>
                    </b-col>
                    <b-col sm="4">
                      <b-row>
                          <b-col sm="5  " class="pr-0">
                            <div class="d-flex">  
                                <label><b>Movement Type</b></label>&nbsp;<span style="color: red;">*</span>
                            </div>
                          </b-col>
                          <b-col sm="7" class="pl-0">
                            <b-form-group>
                                <b-form-select v-model="customer.vehicletype" name="movement_type" v-validate="'required|'" :class="{
                                  input: true,
                                  'is-invalid': errors.has('form-5.movement_type'),
                                  }">
                                  <option value="">--Select--</option>
                                  <option value="inter">Inter City</option>
                                  <option value="intra">Intra City</option>
                                </b-form-select>
                                <span style="width:100px" v-show="errors.has('form-5.movement_type')" class="help text-danger">{{ errors.first("form-5.movement_type") }}</span
                                  >
                            </b-form-group>
                          </b-col>
                      </b-row>
                    </b-col>
                    <b-col sm="4">
                      <b-row>
                          <b-col sm="4" class="pr-0">
                            <div class="d-flex">  
                                <label><b>Vehicle Type</b></label>&nbsp;<span style="color: red;">*</span>
                            </div>
                          </b-col>
                          <b-col sm="8" class="pl-0">
                            <b-form-group>
                                <v-select v-model="customer.vehicletypesize" name="vehicletypesize" :options="vehicleTypeSizeOptions" @input="addVehicleTypeSize" placeholder="-- Select Vehicle Type --" v-validate="'required'" :class="{
                                  input: true,
                                  'is-invalid': errors.has('form-5.vehicletypesize'),
                                  }"></v-select>
                                <b-input-group class="mb-3">
                                  <span style="width:240px" v-show="errors.has('form-5.vehicletypesize')" class="help text-danger">{{
                                  errors.first("form-5.vehicletypesize")
                                  }}</span>
                                </b-input-group>
                            </b-form-group>
                          </b-col>
                      </b-row>
                    </b-col>
                    <b-col sm="4" v-if="vehicletypesizetext">
                      <b-row>
                          <b-col sm="4" class="pr-0">
                            <div class="d-flex">  
                                <label><b>Vehicle Type</b></label>&nbsp;<span style="color: red;">*</span>
                            </div>
                          </b-col>
                          <b-col sm="8" class="pl-0">
                            <b-form-group>
                                <b-form-input type="text" name="vehicle_type_size" v-model="customer.vehicletypesizetext" v-validate="'required|numeric'" :class="{
                                  input: true,
                                  'is-invalid': errors.has('form-5.vehicle_type_size'),
                                  }" placeholder="Enter Vehicle Type">
                                </b-form-input>
                                <b-input-group class="mb-3">
                                  <span class="icon has-text-warning">
                                  <i
                                      class="fa fa-warning"
                                      v-show="errors.has('vehicle_type_size')"
                                      ></i>
                                  </span>
                                  <span style="width:240px" v-show="errors.has('form-5.vehicle_type_size')" class="help text-danger">{{ errors.first("form-5.vehicle_type_size") }}</span>
                                </b-input-group>
                            </b-form-group>
                          </b-col>
                      </b-row>
                    </b-col>
                    <b-col sm="4">
                      <b-row>
                          <b-col sm="4" class="pr-0">
                            <div class="d-flex">  
                                <label><b>Vol Weight</b></label>&nbsp;<span style="color: red;">*</span>
                            </div>
                          </b-col>
                          <b-col sm="8" class="pl-0">
                            <b-form-group>
                                <b-form-input class="input" type="text" v-model="customer.vehicleweightcarrying" name="vehicleweightcarrying" v-validate="'required|decimal:3'" :class="{
                                  input: true,
                                  'is-invalid': errors.has('form-5.vehicleweightcarrying'),
                                  }" placeholder="Enter Vehicle Weight Capacity">
                                </b-form-input>
                                <span style="width:100px" v-show="errors.has('form-5.vehicleweightcarrying')" class="help text-danger">{{ errors.first("form-5.vehicleweightcarrying") }}</span
                                  >
                            </b-form-group>
                          </b-col>
                      </b-row>
                    </b-col>
                    <b-col sm="4">
                      <b-row>
                          <b-col sm="4" class="pr-0">
                            <div class="d-flex">  
                                <label><b>Phy Weight</b></label>&nbsp;<span style="color: red;">*</span>
                            </div>
                          </b-col>
                          <b-col sm="8" class="pl-0">
                            <b-form-group>
                                <b-form-input class="input" type="text" v-model="customer.vehiclephysicalweight" name="vehiclephysicalweight" v-validate="'required|decimal:3'" :class="{
                                  input: true,
                                  'is-invalid': errors.has('form-5.vehiclephysicalweight'),
                                  }" placeholder="Enter Vehicle Weight Capacity">
                                </b-form-input>
                                <span style="width:100px" v-show="errors.has('form-5.vehiclephysicalweight')" class="help text-danger">{{ errors.first("form-5.vehiclephysicalweight") }}</span
                                  >
                            </b-form-group>
                          </b-col>
                      </b-row>
                    </b-col>
              
                    <b-col sm="4">
                      <b-row>
                          <b-col sm="5" class="pr-0">
                            <div class="d-flex">  
                                <label><b>Fuel Type</b></label>&nbsp;<span style="color: red;">*</span>
                            </div>
                          </b-col>
                          <b-col sm="7" class="pl-0">
                            <b-form-group>
                                <v-select v-model="customer.fueltype" name="fueltype" :options="fuelTypeOptions" placeholder="-- Select Fuel Type --" v-validate="'required'" :class="{
                                  input: true,
                                  'is-invalid': errors.has('form-5.fueltype'),
                                  }"></v-select>
                                <b-input-group class="mb-3">
                                  <span style="width:240px" v-show="errors.has('form-5.fueltype')" class="help text-danger">{{
                                  errors.first("form-5.fueltype")
                                  }}</span>
                                </b-input-group>
                            </b-form-group>
                          </b-col>
                      </b-row>
                    </b-col>
                    <b-col sm="4">
                      <b-row>
                          <b-col sm="5" class="pr-0">
                            <div class="d-flex">  
                                <label><b>Upload PUC</b></label>
                            </div>
                          </b-col>
                          <b-col sm="7" class="pl-0">
                            <b-form-group>
                                <div class="d-flex align-items-center">
                                  <b-form-file type="file" v-model="customer.puc_url" @change="pucFileUplod1($event)" id="puc_file" placeholder="Upload PUC" class="custom-border" name="puc_file" :class="{
                                      input: true,
                                      'is-invalid': errors.has('form-5.puc_file'),
                                      }">
                                  </b-form-file>
                                  <b-button variant="primary" class="ms-3" @click="downloadFile(customer.puc_url)" v-b-tooltip.hover="'Download File'">
                                      <i class="fas fa-download"></i>
                                  </b-button>
                                </div>
                                <b-input-group class="mb-3">
                                  <span style="width:240px" v-show="errors.has('form-5.puc_file')" class="help text-danger">{{
                                  errors.first("form-5.puc_file")
                                  }}</span
                                      >
                                </b-input-group>
                            </b-form-group>
                          </b-col>
                      </b-row>
                    </b-col>
                    <b-col sm="4">
                      <b-row>
                          <b-col sm="5" class="pr-0">
                            <div class="d-flex">  
                                <label><b>Upload RC</b></label>
                            </div>
                          </b-col>
                          <b-col sm="7" class="pl-0">
                            <b-form-group>
                                <div class="d-flex align-items-center">
                                  <b-form-file placeholder="Upload RC" class="custom-border" type="file" v-model="customer.registration_url" @change="registrationFileUplod($event)" id="registration_file" name="registration_file" :class="{
                                      input: true,
                                      'is-invalid': errors.has('form-5.registration_file'),
                                      }">
                                  </b-form-file>
                                  <b-button variant="primary" class="ms-3" @click="downloadFile(customer.registration_url)" v-b-tooltip.hover="'Download File'"> <i class="fas fa-download"></i>
                                  </b-button>
                                </div>
                                <b-input-group class="mb-3">
                                  <span style="width:240px" v-show="errors.has('form-5.registration_file')" class="help text-danger">{{
                                  errors.first("form-5.registration_file")
                                  }}</span
                                      >
                                </b-input-group>
                            </b-form-group>
                          </b-col>
                      </b-row>
                    </b-col>
                    <b-col sm="4">
                      <b-row>
                          <b-col sm="5" class="pr-0">
                            <div class="d-flex">  
                                <label><b>Upload Permit</b></label>
                            </div>
                          </b-col>
                          <b-col sm="7" class="pl-0">
                            <b-form-group>
                                <div class="d-flex align-items-center">
                                  <b-form-file placeholder="Upload Permit" class="custom-border" type="file" v-model="customer.permit_url" @change="permitFileUplod($event)" id="permit_file" name="permit_file"  :class="{
                                      input: true,
                                      'is-invalid': errors.has('form-5.permit_file'),
                                      }">
                                  </b-form-file>
                                  <b-button variant="primary" class="ms-3" @click="downloadFile(customer.permit_url)" v-b-tooltip.hover="'Download File'"> <i class="fas fa-download"></i>
                                  </b-button>
                                </div>
                                <b-input-group class="mb-3">
                                  <span style="width:240px" v-show="errors.has('form-5.permit_file')" class="help text-danger">{{
                                  errors.first("form-5.permit_file")
                                  }}</span
                                      >
                                </b-input-group>
                            </b-form-group>
                          </b-col>
                      </b-row>
                    </b-col>
                    <b-col sm="4">
                      <b-row>
                          <b-col sm="5">
                            <div class="d-flex">  
                                <label><b>Upload Insurance</b></label>
                            </div>
                          </b-col>
                          <b-col sm="7">
                            <b-form-group>
                                <div class="d-flex align-items-center">
                                  <b-form-file placeholder="Upload Insurance File" class="custom-border" type="file" v-model="customer.insurance_url" @change="insuranceFileUplod($event)"  id="insurance_file" name="insurance_file" :class="{
                                      input: true,
                                      'is-invalid': errors.has('form-5.insurance_file'),
                                      }">
                                  </b-form-file>
                                  <b-button variant="primary" class="ms-3" @click="downloadFile(customer.insurance_url)" v-b-tooltip.hover="'Download File'"> <i class="fas fa-download"></i>
                                  </b-button>
                                </div>
                                <b-input-group class="mb-3">
                                  <span style="width:240px" v-show="errors.has('form-5.insurance_file')" class="help text-danger">{{
                                  errors.first("form-5.insurance_file")
                                  }}</span
                                      >
                                </b-input-group>
                            </b-form-group>
                          </b-col>
                      </b-row>
                    </b-col>
                    <b-col sm="4" v-if="customer.vehicletype !== 'adhoc'">
                      <b-row>
                          <b-col sm="5" class="pr-0">
                            <div class="d-flex">  
                                <label><b>Labor Charges</b></label>
                            </div>
                          </b-col>
                          <b-col sm="7" class="pl-0">
                            <b-form-group>
                                <b-form-input class="input" type="text" v-model="customer.labour_charges" name="labour_charges" :class="{
                                  input: true,
                                  'is-invalid': errors.has('form-5.labour_charges'),
                                  }" placeholder="Enter Labour Charges">
                                </b-form-input>
                                <span style="width:100px" v-show="errors.has('form-5.labour_charges')" class="help text-danger">{{ errors.first("form-5.labour_charges") }}</span
                                  >
                            </b-form-group>
                          </b-col>
                      </b-row>
                    </b-col>
                    <b-col sm="4" v-if="customer.vehicletype !== 'adhoc'">
                      <b-row>
                          <b-col sm="5" class="pr-0">
                            <div class="d-flex">  
                                <label><b>Fixed KM's</b></label>
                            </div>
                          </b-col>
                          <b-col sm="7" class="pl-0">
                            <b-form-group>
                                <b-form-input class="input" type="text" v-model="customer.fixed_kms" name="fixed_kms"  :class="{
                                  input: true,
                                  'is-invalid': errors.has('form-5.fixed_kms'),
                                  }" placeholder="Enter Fixed Kms">
                                </b-form-input>
                                <span style="width:100px" v-show="errors.has('form-5.fixed_kms')" class="help text-danger">{{ errors.first("form-5.fixed_kms") }}</span
                                  >
                            </b-form-group>
                          </b-col>
                      </b-row>
                    </b-col>
                    <b-col sm="4" v-if="customer.vehicletype !== 'adhoc'">
                      <b-row>
                          <b-col sm="5" class="pr-0">
                            <div class="d-flex">  
                                <label><b>Fixed Freight rate</b></label>
                            </div>
                          </b-col>
                          <b-col sm="7" class="pl-0">
                            <b-form-group>
                                <b-form-input class="input" type="text" v-model="customer.fixed_freightrate" name="fixed_freightrate"  :class="{
                                  input: true,
                                  'is-invalid': errors.has('form-5.fixed_freightrate'),
                                  }" placeholder="Enter Fixed Freight rate">
                                </b-form-input>
                                <span style="width:100px" v-show="errors.has('form-5.fixed_freightrate')" class="help text-danger">{{ errors.first("form-5.fixed_freightrate") }}</span
                                  >
                            </b-form-group>
                          </b-col>
                      </b-row>
                    </b-col>
                    <b-col sm="4" v-if="customer.vehicletype !== 'adhoc'">
                      <b-row>
                          <b-col sm="5" class="pr-0">
                            <div class="d-flex">  
                                <label><b>Extra KM rate</b></label>
                            </div>
                          </b-col>
                          <b-col sm="7" class="pl-0">
                            <b-form-group>
                                <b-form-input class="input" type="text" v-model="customer.extra_kmrate" name="extra_kmrate"  :class="{
                                  input: true,
                                  'is-invalid': errors.has('form-5.extra_kmrate'),
                                  }" placeholder="Enter Extra KM rate">
                                </b-form-input>
                                <span style="width:100px" v-show="errors.has('form-5.extra_kmrate')" class="help text-danger">{{ errors.first("form-5.extra_kmrate") }}</span
                                  >
                            </b-form-group>
                          </b-col>
                      </b-row>
                    </b-col>
                    <b-col sm="4" v-if="customer.vehicletype !== 'adhoc'">
                      <b-row>
                          <b-col sm="5" class="pr-0">
                            <div class="d-flex">  
                                <label><b>Total Days
                                </b></label>
                            </div>
                          </b-col>
                          <b-col sm="7" class="pl-0">
                            <b-form-group>
                                <b-form-input class="input" type="text" v-model="customer.workingdays" name="workingdays"  :class="{
                                  input: true,
                                  'is-invalid': errors.has('form-5.workingdays'),
                                  }" placeholder="Enter Total days" disabled>
                                </b-form-input>
                                <span style="width:100px" v-show="errors.has('form-5.workingdays')" class="help text-danger">{{ errors.first("form-5.workingdays") }}</span
                                  >
                            </b-form-group>
                          </b-col>
                      </b-row>
                    </b-col>
                    <b-col sm="6">
                      <b-row>
                          <b-col sm="3" class="pr-0">
                            <div class="d-flex">  
                                <label><b>Payment Type</b></label>
                            </div>
                          </b-col>
                          <b-col sm="7" class="pl-0">
                            <b-form-group>
                               
                                <b-form-radio-group v-model="customer.paymenttype" v-validate="'required'" :options="[
                                  { text: 'Daily', value: 'tripend' }, 
                                  { text: 'Weekly', value: 'weekly' },
                                  { text: 'Monthly', value: 'monthly' }
                                  ]" name="payment_type" id="payment_type" :class="{
                                  input: true,
                                  'is-invalid': errors.has('form-5.payment_type'),
                                  }">
                                </b-form-radio-group>
                                <b-input-group class="mb-3">
                                  <span style="width:240px" v-show="errors.has('form-5.payment_type')" class="help text-danger">{{
                                  errors.first("form-5.payment_type")
                                  }}</span
                                      >
                                </b-input-group>
                            </b-form-group>
                          </b-col>
                      </b-row>
                      <!-- </div> -->
                    </b-col>
                </b-row>
                <hr />
                <br />
                <h6 style="text-align:center"><b>Update Driver Info</b></h6>
                <br />
                <b-row>
                    <b-col sm="4">
                      <b-row>
                          <b-col sm="4" class="pr-0">
                            <div class="d-flex">  
                                <label><b>First Name</b></label>&nbsp;<span style="color: red;">*</span>
                            </div>
                          </b-col>
                          <b-col sm="8" class="pl-0">
                            <b-form-group>
                                <b-form-input class="input" type="text" id="driverfirstname" name="driverfirstname" v-model="customer.driverfirstname" v-validate="'required|alpha|min:3|max:30'" :class="{
                                  input: true,
                                  'is-invalid': errors.has('form-5.driverfirstname'),
                                  }" placeholder="Enter First Name">
                                </b-form-input>
                                <span style="width:100px" v-show="errors.has('form-5.driverfirstname')" class="help text-danger">{{ errors.first("form-5.driverfirstname") }}</span
                                  >
                            </b-form-group>
                          </b-col>
                      </b-row>
                    </b-col>
                    <b-col sm="4">
                      <b-row>
                          <b-col sm="4" class="pr-0">
                            <div class="d-flex">  
                                <label><b>Last Name</b></label>&nbsp;<span style="color: red;">*</span>
                            </div>
                          </b-col>
                          <b-col sm="8" class="pl-0">
                            <b-form-group>
                                <b-form-input class="input" type="text" id="driverlastname" name="driverlastname" v-model="customer.driverlastname" v-validate="'required|alpha|min:3|max:30'" :class="{
                                  input: true,
                                  'is-invalid': errors.has('form-5.driverlastname'),
                                  }" placeholder="Enter First Name">
                                </b-form-input>
                                <span style="width:100px" v-show="errors.has('form-5.driverlastname')" class="help text-danger">{{ errors.first("form-5.driverlastname") }}</span
                                  >
                            </b-form-group>
                          </b-col>
                      </b-row>
                    </b-col>
                    <b-col sm="4">
                      <b-row>
                          <b-col sm="4" class="pr-0">
                            <div class="d-flex">  
                                <label><b>Mobile No</b></label>&nbsp;<span style="color: red;">*</span>
                            </div>
                          </b-col>
                          <b-col sm="8" class="pl-0">
                            <b-form-group>
                                <b-form-input class="input" type="text" maxlength="10" v-model="customer.mobile_no" name="mobile_no" v-validate="'required|digits:10'" :class="{
                                  input: true,
                                  'is-invalid': errors.has('form-5.mobile_no'),
                                  }" placeholder="Enter Mobile Number ">
                                </b-form-input>
                                <span style="width:100px" v-show="errors.has('form-5.mobile_no')" class="help text-danger">{{ errors.first("form-5.mobile_no") }}</span
                                  >
                            </b-form-group>
                          </b-col>
                      </b-row>
                    </b-col>
                    <b-col sm="4">
                      <b-row>
                          <b-col sm="4" class="pr-0">
                            <div class="d-flex">  
                                <label><b>Alt Mobile No</b></label>
                            </div>
                          </b-col>
                          <b-col sm="8" class="pl-0">
                            <b-form-group>
                                <b-form-input class="input" type="text" maxlength="10" v-model="customer.altmobile_no" name="altmobile_no" v-validate="'digits:10'" :class="{
                                  input: true,
                                  'is-invalid': errors.has('form-5.altmobile_no'),
                                  }" placeholder="Enter Mobile Number ">
                                </b-form-input>
                                <span style="width:100px" v-show="errors.has('form-5.altmobile_no')" class="help text-danger">{{ errors.first("form-5.altmobile_no") }}</span
                                  >
                            </b-form-group>
                          </b-col>
                      </b-row>
                    </b-col>
                    <b-col sm="4">
                      <b-row>
                          <b-col sm="4" class="pr-0">
                            <div class="d-flex">  
                                <label><b>Driving License</b></label>&nbsp;<span style="color: red;">*</span>
                            </div>
                          </b-col>
                          <b-col sm="8" class="pl-0">
                            <b-form-group>
                                <b-form-input class="input" type="text" v-model="customer.driving_license" name="driving_license" v-validate="'required'" :class="{
                                  input: true,
                                  'is-invalid': errors.has('form-5.driving_license'),
                                  }" placeholder="Enter Driving License">
                                </b-form-input>
                                <span style="width:100px" v-show="errors.has('form-5.driving_license')" class="help text-danger">{{ errors.first("form-5.driving_license") }}</span
                                  >
                            </b-form-group>
                          </b-col>
                      </b-row>
                    </b-col>
                    <b-col sm="4">
                      <b-row>
                          <b-col sm="4" class="pr-0">
                            <div class="d-flex">  
                                <label><b>Driver's License</b></label>
                            </div>
                          </b-col>
                          <b-col sm="8" class="pl-0">
                            <!-- <div class="d-flex align-items-center"> -->
                            <b-form-group class="mb-3">
                                <div class="d-flex align-items-center">
                                  <b-form-file variant="primary" type="file" v-model="customer.licence_url" placeholder="Upload DL" class="custom-border"  @change="driverLicenseFileUplod($event)" id="driver_license" name="driver_license" :class="{
                                      input: true,
                                      'is-invalid': errors.has('form-5.driver_license'),
                                      }">
                                  </b-form-file>
                                  <b-button variant="primary" class="ms-1" @click="downloadFile(customer.licence_url)" v-b-tooltip.hover="'Download File'">
                                      <i class="fas fa-download"></i>
                                  </b-button>
                                </div>
                                <b-input-group class="mb-3">
                                  <span class="icon has-text-warning">
                                  <i
                                      class="fa fa-warning"
                                      v-show="errors.has('driver_license')"
                                      ></i>
                                  </span>
                                  <span style="width:240px" v-show="errors.has('form-5.driver_license')" class="help text-danger">{{ errors.first("form-5.driver_license") }}</span
                                      >
                                </b-input-group>
                            </b-form-group>
                          </b-col>
                      </b-row>
                    </b-col>
                </b-row>
                <hr />
                <br />
                <h6 style="text-align:center"><b>Update Helper Info</b></h6>
                <br />
                <b-row>
                    <b-col sm="4">
                      <b-row>
                          <b-col sm="4" class="pr-0">
                            <div class="d-flex">  
                                <label><b>First Name</b></label>&nbsp;<span style="color: red;">*</span>
                            </div>
                          </b-col>
                          <b-col sm="8" class="pl-0">
                            <b-form-group>
                                <b-form-input class="input" type="text" id="helperfirstname" name="helperfirstname" v-model="customer.helperfirstname" v-validate="'required|alpha|min:3|max:30'" :class="{
                                  input: true,
                                  'is-invalid': errors.has('form-5.helperfirstname'),
                                  }" placeholder="Enter First Name">
                                </b-form-input>
                                <span style="width:100px" v-show="errors.has('form-5.helperfirstname')" class="help text-danger">{{ errors.first("form-5.helperfirstname") }}</span
                                  >
                            </b-form-group>
                          </b-col>
                      </b-row>
                    </b-col>
                    <b-col sm="4">
                      <b-row>
                          <b-col sm="4" class="pr-0">
                            <div class="d-flex">  
                                <label><b>Last Name</b></label>&nbsp;<span style="color: red;">*</span>
                            </div>
                          </b-col>
                          <b-col sm="8" class="pl-0">
                            <b-form-group>
                                <b-form-input class="input" type="text" id="helperlastname" name="helperlastname" v-model="customer.helperlastname" v-validate="'required|alpha|min:3|max:30'" :class="{
                                  input: true,
                                  'is-invalid': errors.has('form-5.helperlastname'),
                                  }" placeholder="Enter First Name">
                                </b-form-input>
                                <span style="width:100px" v-show="errors.has('form-5.helperlastname')" class="help text-danger">{{ errors.first("form-5.helperlastname") }}</span
                                  >
                            </b-form-group>
                          </b-col>
                      </b-row>
                    </b-col>
                    <b-col sm="4">
                      <b-row>
                          <b-col sm="4" class="pr-0">
                            <div class="d-flex">  
                                <label><b>Mobile No</b></label>&nbsp;<span style="color: red;">*</span>
                            </div>
                          </b-col>
                          <b-col sm="8" class="pl-0">
                            <b-form-group>
                                <b-form-input class="input" type="text" id="addmobilenumber" name="mobilenumber" maxlength="10" v-model="customer.helpermobilenumber" v-validate="'required|digits:10'" :class="{
                                  input: true,
                                  'is-invalid': errors.has('form-5.mobilenumber'),
                                  }" placeholder="Enter Mobile Number">
                                </b-form-input>
                                <span style="width:100px" v-show="errors.has('form-5.mobilenumber')" class="help text-danger">{{ errors.first("form-5.mobilenumber") }}</span
                                  >
                            </b-form-group>
                          </b-col>
                      </b-row>
                    </b-col>
                    <b-col sm="4">
                      <b-row>
                          <b-col sm="4" class="pr-0">
                            <div class="d-flex">  
                                <label><b>Alt Mobile No</b></label>
                            </div>
                          </b-col>
                          <b-col sm="8" class="pl-0">
                            <b-form-group>
                                <b-form-input class="input" type="text" id="addaltenatemobilenumber" name="helperaltmobilenumber" maxlength="10" v-model="customer.helperaltmobilenumber" v-validate="'digits:10'" :class="{
                                  input: true,
                                  'is-invalid': errors.has('form-5.helperaltmobilenumber'),
                                  }" placeholder="Enter Alternate Mobile Number">
                                </b-form-input>
                                <span style="width:100px" v-show="errors.has('form-5.helperaltmobilenumber')" class="help text-danger">{{ errors.first("form-5.helperaltmobilenumber") }}</span
                                  >
                            </b-form-group>
                          </b-col>
                      </b-row>
                    </b-col>
                </b-row>
                <hr />
                <br />
                <h6 style="text-align:center"><b>Update Transporter Info</b></h6>
                <br />
                <b-row>
                    <b-col sm="4">
                      <b-form-group :label-cols="4">
                          <template v-slot:label>
                            Type of Vendor <span style="color: red;">*</span>
                          </template>
                          <b-form-radio-group id="vendor type" v-model="customer.vendortype" v-validate="'required'" :options="[
                            { text: 'Aggregator', value: 'aggregator' }, 
                            { text: 'Normal', value: 'normal' }
                            ]" name="vendor type">
                          </b-form-radio-group>
                          <b-input-group class="mb-3">
                            <span style="width:240px" v-show="errors.has('form-5.vendor type')" class="help text-danger">{{ errors.first("form-5.vendor type") }}</span>
                          </b-input-group>
                      </b-form-group>
                    </b-col>
                    <b-col sm="4">
                      <b-row>
                          <b-col sm="5" class="pr-0">
                            <div class="d-flex">  
                                <label><b>Company Name</b></label>&nbsp;<span style="color: red;">*</span>
                            </div>
                          </b-col>
                          <b-col sm="7" class="pl-0">
                            <b-form-group>
                                <v-select v-model="transporterCompanyName" :options="optionmailid" @input="updateTextbox" placeholder="-- Select Company --" :class="{
                                  input: true,
                                  'is-danger': errors.has('form-5.companyname'),
                                  }" name="companyname" v-validate="'required|min:3|max:50'"></v-select>
                                <!-- <span
                                  v-show="errors.has('form-5.companyname')"
                                  class="help text-danger"
                                  >{{ errors.first("form-5.companyname") }}</span
                                  > -->
                                <b-input-group class="mb-3">
                                  <span style="width:240px" v-show="errors.has('form-5.companyname')" class="help text-danger">{{ errors.first("form-5.companyname") }}</span>
                                </b-input-group>
                            </b-form-group>
                          </b-col>
                      </b-row>
                    </b-col>
                    <b-col sm="4">
                      <b-form-group label="Transporter Name" :label-cols="4">
                          <b-form-input class="input" type="text" v-model="customer.driver_contracter_name" name="driver_contracter_name" v-validate="'required|alpha_spaces'" placeholder="Enter Driver Transporter Name" disabled>
                          </b-form-input>
                      </b-form-group>
                    </b-col>
                    <b-col sm="4">
                      <b-form-group label="Mobile No" :label-cols="4">
                          <b-form-input class="input" type="text" id="contractormobilenumber" name="mobilenumber" maxlength="10" v-model="customer.contractormobilenumber" placeholder="Enter Mobile Number" disabled>
                          </b-form-input>
                          <!-- v-validate="'required|digits:10'"
                            :class="{
                              input: true,
                              'text-danger': errors.has('form-5.mobilenumber'),
                            }" -->
                          <!-- <span
                            style="width:100px"
                            v-show="errors.has('form-5.mobilenumber')"
                            class="help text-danger"
                            >{{ errors.first("form-5.mobilenumber") }}</span
                            > -->
                      </b-form-group>
                    </b-col>
                    <b-col sm="4">
                      <b-form-group label="Email ID88" :label-cols="4" disabled>
                          <b-form-input class="input" type="text" v-model="customer.contracter_emailid" name="contracter_emailid" v-validate="'required|email'" placeholder="Enter Transporter Email ID" disabled>
                          </b-form-input>
                          <!-- <span
                            style="width:100px"
                            v-show="errors.has('form-5.contracter_emailid')"
                            class="help text-danger"
                            >{{ errors.first("form-5.contracter_emailid") }}</span
                            > -->
                      </b-form-group>
                    </b-col>
                    <b-col sm="4">
                      <b-form-group label="Tin Number / GST Number" :label-cols="4">
                          <b-form-input name="GST Number" type="text" v-model="customer.transporter_gstnumber" @input="checkGSTlength(customer.transporter_gstnumber)" placeholder="Enter Tin Number / GST Number" :class="{ input: true, 'is-invalid': errors_GST,
                            }">
                          </b-form-input>
                          <b-input-group class="mb-3">
                            <span class="icon has-text-warning">
                            <i class="fa fa-warning" v-show="errors.has('GST Number')"></i>
                            </span>
                            <code v-show="errors.has('form-5.GST Number')" id="GST Number" class="help text-danger">{{ errors.first("form-5.GST Number") }}
                            </code>
                          </b-input-group>
                      </b-form-group>
                    </b-col>
                   
                  
                    <b-col sm="4">
                      <b-form-group :label-cols="4">
                          <template v-slot:label>
                            PAN 
                          </template>
                          
                          <b-input-group class="mb-3">
                            <b-form-input class="input" type="text" id="pan number" name="pan number" v-model="customer.pan" v-validate="'max:50'" :class="{
                                input: true,'is-invalid': errors.has('form-5.pan number'),}" placeholder="Enter PAN Number"></b-form-input>
                          </b-input-group>
                          <b-input-group class="mb-3">
                            <span class="icon has-text-warning">
                            <i class="fa fa-warning" v-show="errors.has('panno')"></i>
                            </span>
                            <code v-show="errors.has('form-5.pan number')" id="addpannoerrmsg" class="help text-danger">{{ errors.first("form-5.pan number") }}
                            </code>
                          </b-input-group>
                      </b-form-group>
                    </b-col>
                    <b-col sm="4">
                      <b-form-group :label-cols="4">
                          <template v-slot:label>
                            Aadhaar
                          </template>
                         
                          <b-input-group class="mb-3">
                            <b-form-input class="input" type="text" id="adhaar number" name="adhaar number" v-model="customer.aadhar" v-validate="'max:50'" :class="{
                                input: true,'is-invalid': errors.has('form-5.adhaar number'),}" placeholder="Enter Aadhaar Number"></b-form-input>
                          </b-input-group>
                          <b-input-group class="mb-3">
                            <span class="icon has-text-warning">
                            <i class="fa fa-warning" v-show="errors.has('adhaarno')"></i>
                            </span>
                            <code v-show="errors.has('form-5.adhaar number')" id="addpannoerrmsg" class="help text-danger">{{ errors.first("form-5.adhaar number") }}
                            </code>
                          </b-input-group>
                      </b-form-group>
                    </b-col>
                    <b-col sm="4">
                      <b-form-group :label-cols="4">
                          <template v-slot:label>
                            Bank Cancelled Cheque 
                          </template>
                          <div class="d-flex align-items-center">
                            <b-form-file type="file" v-model="customer.bankcancelledcheque" placeholder="Bank Cancelled Cheque" @change="selectBankChequeFile($event)" class="custom-border" id="bank cancelled cheque" name="bank cancelled cheque" :class="{
                                input: true,'is-invalid': errors.has('form-5.bank cancelled cheque'),}">
                                <template v-slot:file-name>
                                  {{ bankFileName }}
                                </template>
                            </b-form-file>
                            <!-- Download Button -->
                            <b-button variant="primary" class="ms-3" @click="downloadFile(customer.bankcancelledcheque)" v-b-tooltip.hover="'Download File'">
                                <i class="fas fa-download"></i>
                            </b-button>
                          </div>
                          <b-input-group class="mb-3">
                            <code v-show="errors.has('form-5.bank cancelled cheque')" id="addpannoerrmsg" class="help text-danger">{{ errors.first("form-5.bank cancelled cheque") }}
                            </code>
                          </b-input-group>
                      </b-form-group>
                    </b-col>
                    <b-col sm="4">
                      <b-form-group :label-cols="4">
                          <template v-slot:label>
                            GSTIN Certificate
                          </template>
                          <div class="d-flex align-items-center">
                            <b-form-file type="file" v-model="customer.gstincertificate" placeholder="GSTIN Certificate" @change="selectGstinCertficateFile($event)" class="custom-border" id="gstin certficate" name="gstin certficate" :class="{
                                input: true,'is-invalid': errors.has('form-5.gstin certficate'),}">
                                <template v-slot:file-name>
                                  {{ gstinCertficateFilename }}
                                </template>
                            </b-form-file>
                            <b-button variant="primary" class="ms-3" @click="downloadFile(customer.gstincertificate)" v-b-tooltip.hover="'Download File'">
                                <i class="fas fa-download"></i>
                            </b-button>
                          </div>
                          <b-input-group class="mb-3">
                            <span class="icon has-text-warning">
                            <i class="fa fa-warning" v-show="errors.has('gstin certficate')"></i>
                            </span>
                            <code v-show="errors.has('form-5.gstin certficate')" id="gstincertficateerrmsg" class="help text-danger">{{ errors.first("form-5.gstin certficate") }}
                            </code>
                          </b-input-group>
                      </b-form-group>
                    </b-col>
                    <b-col sm="4">
                      <b-form-group :label-cols="4">
                          <template v-slot:label>
                            Pincode
                          </template>
                          <!-- <label for="pincode">Pincode</label>&nbsp; -->
                          <v-select v-model="customer.pincode" :options="pincodes" placeholder="-- Select Pincode --" @change="pincodeChange(customer.pincode)"></v-select>
                          <b-input-group class="mb-3">
                            <span style="width:240px" v-show="errors.has('form-5.pincode')" class="help text-danger">{{
                            errors.first("form-5.pincode")
                            }}</span
                                >
                          </b-input-group>
                      </b-form-group>
                    </b-col>
                    <b-col sm="4">
                      <b-form-group :label-cols="4">
                          <template v-slot:label>
                            Address 
                          </template>
                         
                          <b-input-group class="mb-3">
                            <b-form-input class="input"  type="text" id="address" name="address" v-model="customer.address" :class="{
                                input: true,'is-invalid': errors.has('form-5.address'),}" placeholder="Enter Address"></b-form-input>
                          </b-input-group>
                          <b-input-group class="mb-3">
                            <span class="icon has-text-warning">
                            <i class="fa fa-warning" v-show="errors.has('address')"></i>
                            </span>
                            <code v-show="errors.has('form-5.address')" id="addresserrmsg" class="help text-danger">{{ errors.first("form-5.address") }}
                            </code>
                          </b-input-group>
                      </b-form-group>
                    </b-col>
                    <b-col sm="4" v-if="customer.pincode">
                      <b-form-group :label-cols="4">
                          <template v-slot:label>
                            City
                          </template>
                          <!-- <label for="city">City</label>&nbsp; -->
                          <b-input-group class="mb-3">
                            <b-form-input class="input" type="text" id="city" name="city" v-model="customer.city" :class="{
                                input: true,'is-invalid': errors.has('form-5.city'),}" placeholder=""></b-form-input>
                          </b-input-group>
                          <b-input-group class="mb-3">
                            <span class="icon has-text-warning">
                            <i class="fa fa-warning" v-show="errors.has('city')"></i>
                            </span>
                            <code v-show="errors.has('form-5.city')" id="addresserrmsg" class="help text-danger">{{ errors.first("form-5.address") }}
                            </code>
                          </b-input-group>
                      </b-form-group>
                    </b-col>
                    <b-col sm="4" v-if="customer.pincode">
                      <b-form-group :label-cols="4">
                          <template v-slot:label>
                            State
                          </template>
                          <!-- <label for="state">State</label>&nbsp; -->
                          <b-input-group class="mb-3">
                            <b-form-input class="input" type="text" id="state" name="state" v-model="customer.state" :class="{
                                input: true,'is-invalid': errors.has('form-5.state'),}" placeholder=""></b-form-input>
                          </b-input-group>
                          <b-input-group class="mb-3">
                            <span class="icon has-text-warning">
                            <i class="fa fa-warning" v-show="errors.has('state')"></i>
                            </span>
                            <code v-show="errors.has('form-5.state')" id="addresserrmsg" class="help text-danger">{{ errors.first("form-5.state") }}
                            </code>
                          </b-input-group>
                      </b-form-group>
                    </b-col>
                    <b-col sm="4">
                      <b-form-group :label-cols="4">
                          <template v-slot:label>
                            Bank name 
                          </template>
                          <!-- <label for="bankname">Bank name</label>&nbsp;<span style="color: red;">*</span> -->
                          <b-input-group class="mb-3">
                            <b-form-input class="input"  type="text" id="bankname" name="bankname" v-model="customer.bankname" :class="{
                                input: true,'is-invalid': errors.has('form-5.bankname'),}" placeholder="Enter Bank name"></b-form-input>
                          </b-input-group>
                          <b-input-group class="mb-3">
                            <span class="icon has-text-warning">
                            <i class="fa fa-warning" v-show="errors.has('bankname')"></i>
                            </span>
                            <code v-show="errors.has('form-5.bankname')" id="banknameerrmsg" class="help text-danger">{{ errors.first("form-5.bankname") }}
                            </code>
                          </b-input-group>
                      </b-form-group>
                    </b-col>
                    <b-col sm="4">
                      <b-form-group :label-cols="4">
                          <template v-slot:label>
                            Bank Account Name
                          </template>
                          <!-- <label for="bankaccountname">Bank Account Name</label>&nbsp;<span style="color: red;">*</span> -->
                          <b-input-group class="mb-3">
                            <b-form-input class="input" type="text" id="bankaccountname" name="bankaccountname" v-model="customer.bankaccountname" :class="{
                                input: true,'is-invalid': errors.has('form-5.bankaccountname'),}" placeholder="Enter Bank Account Name"></b-form-input>
                          </b-input-group>
                          <b-input-group class="mb-3">
                            <span class="icon has-text-warning">
                            <i class="fa fa-warning" v-show="errors.has('bankaccountname')"></i>
                            </span>
                            <code v-show="errors.has('form-5.bankaccountname')" id="bankaccountnameerrmsg" class="help text-danger">{{ errors.first("form-5.bankaccountname") }}
                            </code>
                          </b-input-group>
                      </b-form-group>
                    </b-col>
                    <b-col sm="4">
                      <b-form-group :label-cols="4">
                          <template v-slot:label>
                            Branch Name
                          </template>
                          <!-- <label for="branchname">Branch Name</label>&nbsp;<span style="color: red;">*</span> -->
                          <b-input-group class="mb-3">
                            <b-form-input class="input" type="text" id="branchname" name="branchname" v-model="customer.branchname" :class="{
                                input: true,'is-invalid': errors.has('form-5.branchname'),}" placeholder="Enter Branch Name"></b-form-input>
                          </b-input-group>
                          <b-input-group class="mb-3">
                            <span class="icon has-text-warning">
                            <i class="fa fa-warning" v-show="errors.has('branchname')"></i>
                            </span>
                            <code v-show="errors.has('form-5.branchname')" id="branchnameerrmsg" class="help text-danger">{{ errors.first("form-5.branchname") }}
                            </code>
                          </b-input-group>
                      </b-form-group>
                    </b-col>
                    <b-col sm="4">
                      <b-form-group :label-cols="4">
                          <template v-slot:label>
                            Account number
                          </template>
                         
                          <b-input-group class="mb-3">
                            <b-form-input class="input"  type="text" id="accountnumber" name="accountnumber" v-model="customer.accountnumber" :class="{
                                input: true,'is-invalid': errors.has('form-5.accountnumber'),}" placeholder="Enter Account number"></b-form-input>
                          </b-input-group>
                          <b-input-group class="mb-3">
                            <span class="icon has-text-warning">
                            <i class="fa fa-warning" v-show="errors.has('accountnumber')"></i>
                            </span>
                            <code v-show="errors.has('form-5.accountnumber')" id="accountnumbererrmsg" class="help text-danger">{{ errors.first("form-5.accountnumber") }}
                            </code>
                          </b-input-group>
                      </b-form-group>
                    </b-col>
                    <b-col sm="4">
                      <b-form-group :label-cols="4">
                          <template v-slot:label>
                            IFSC Code
                          </template>
                          
                          <b-input-group class="mb-3">
                            <b-form-input class="input" type="text" id="ifsccode" name="ifsccode" v-model="customer.ifsccode" :class="{
                                input: true,'is-invalid': errors.has('form-5.ifsccode'),}" placeholder="Enter IFSC Code"></b-form-input>
                          </b-input-group>
                          <b-input-group class="mb-3">
                            <span class="icon has-text-warning">
                            <i class="fa fa-warning" v-show="errors.has('ifsccode')"></i>
                            </span>
                            <code v-show="errors.has('form-5.ifsccode')" id="ifsccodeerrmsg" class="help text-danger">{{ errors.first("form-5.ifsccode") }}
                            </code>
                          </b-input-group>
                      </b-form-group>
                    </b-col>
                    <b-col sm="4">
                      <button type="button" class="btn btn-outline-success btn-md" v-if="showverifybutton" @click="verifyGSTNo()">Verify</button>&nbsp;
                      <button type="button" class="btn btn-outline-danger btn-md" v-if="removeGST" @click="removevalue()">X</button>
                    </b-col>
                </b-row>
                <hr />
                <br />
                <div slot="footer" class="text-right">
                    <div id="overlayModal">
                      <div class="loaderModal"></div>
                    </div>
                    <b-button type="submit" size="sm" class="mr-4" variant="primary" id="submitButton" v-if="HideAnyAction!='Yes'">
                      Update
                    </b-button>
                    <b-button size="sm" variant="danger" @click="editcancel()">cancel</b-button>
                </div>
              </b-form>
              

          </template>
          <template slot="modal-footer" slot-scope="{ hide }">
            <!-- Emulate built in modal footer ok and cancel button actions -->
            <b-button size="sm" style="display:none">
                Cancel
            </b-button>
            <!-- Button with custom close trigger value -->
          </template>
      </b-modal>

<!-- End -->
  
      <!-- Edit Vehicle Admin -->
      <b-modal title="Edit Vehicle Admin" size="md" v-model="vehicleCityWHmodal" @ok="vehicleCityWHmodal = false" hide-footer>
        <template slot="default" slot-scope="{ hide }">
          <form @submit.prevent="validateForm('form-1')" data-vv-scope="form-1">
            <div class="modal-card">
              <section class="modal-card-body">
                <b-col sm="12">
                  <b-row>
                    <b-col sm="4" class="pr-0">
                      <label><b>Select Admin</b></label>&nbsp;<span style="color: red;">*</span>
                    </b-col>&nbsp;
                    <b-col sm="7" class="pl-0">
                      <div id="container">
                        <b-form-group>
                          <ejs-multiselect
                          id="multi_select"
                          placeholder="Select Admin"
                          v-model="valueAdmin"
                          @change="selectAdmin"
                          :dataSource="optionsAdmin"
                          :fields="fieldAdmin"
                          name="Admin"
                          v-validate="'required|'"
                            :class="{
                              input: true,
                              'is-invalid': errors.has('form-1.Admin'),
                            }" 
                          ></ejs-multiselect>
                          <span
                            v-show="errors.has('form-1.Admin')"
                            class="help text-danger"
                            >{{ errors.first("form-1.Admin") }}</span
                          >
                        </b-form-group>
                      </div>
                    </b-col>
                  </b-row>
                </b-col>
  
                <b-col sm="12">
                  <b-row>
                    <b-col sm="4" class="pr-0">
                      <label><b>Select City</b></label>&nbsp;<span style="color: red;">*</span>
                    </b-col>
                    <b-col sm="8" class="pl-0">
                      <div id="container">
                        <b-form-group>
                          <ejs-multiselect 
                          id="multi_select" placeholder="Select City" v-model="valueWHAdmin" @change="selectWHAdmin" :dataSource="warehouseAdmin" :fields="fieldwhAdmin" name="City" v-validate="'required'" :class="{ input: true, 'is-invalid': errors.has('form-1.City'),}">
                        </ejs-multiselect>
                          <span
                          v-show="errors.has('form-1.City')"
                          class="help text-danger"
                          >{{ errors.first("form-1.City") }}</span
                        >
                        </b-form-group>
                      </div>
                    </b-col>
                  </b-row>
                </b-col>
              </section>
              <footer class="text-right">
                <div id="overlayModal">
                  <div class="loaderModal"></div>
                </div>
                <b-button size="sm" variant="primary" type="submit" class="mr-4"
                v-if="HideAnyAction!='Yes'">Update</b-button
                >
                <b-button size="sm" variant="danger" @click="editCityWHcancel()">
                  Cancel
                </b-button>
              </footer>
            </div>
          </form>
        </template>
        <template slot="modal-footer" slot-scope="{ cancel }">
          <!-- Emulate built in modal footer ok and cancel button actions -->
          <b-button
            size="sm"
            variant="danger"
            @click="vehicle()"
            style="display:none"
          >
            Cancel
          </b-button>
          <!-- Button with custom close trigger value -->
        </template>
      </b-modal>
  
      <!-- change password -->
      <b-modal
        title="Change Password"
        size="md"
        v-model="resetPassword"
        @ok="resetPassword = false"
        hide-footer>
        <template slot="default" slot-scope="{ hide }">
          <form @submit.prevent="validateForm4('form-4')" data-vv-scope="form-4">
            <div class="modal-background"></div>
            <div class="modal-card">
              <section class="modal-card-body">
                <div class="field">
                  <p class="control">
                    <span style="color: red;"
                      >Strong Passowrd Rules:<br />
  
                      1)Your password must be between 6 to 14 character<br />
                      2)Password must contain at least one lowercase and uppercase
                      character<br />
                      3)Password must contain at least one number<br />
                      4)Password must contain at least one special character
                      <br />
                    </span>
                    <b-form-input
                      class="input"
                      type="text"
                      name="password"
                      minlength="6"
                      maxlength="14"
                      v-model="customer.deliveryagentpassword"
                      v-validate="{
                        required: true,
                        regex: /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#\$%\^&\*])(?=.{6,12})/,
                      }"
                      :class="{
                        input: true,
                        'text-danger': errors.has('form-4.password'),
                      }"
                      placeholder="Enter password"
                    />
                    <code
                      v-show="errors.has('form-4.password')"
                      class="help text-danger"
                      >{{ errors.first("form-4.password") }}</code
                    >
                  </p>
                </div>
              </section>
              <footer class="text-right">
                <div id="overlayModal">
                  <div class="loaderModal"></div>
                </div>
                <b-button size="sm" variant="primary" type="submit" class="mr-4"
                v-if="HideAnyAction!='Yes'">Update</b-button
                >
                <b-button size="sm" variant="danger" @click="cancelPassword()">
                  Cancel
                </b-button>
              </footer>
            </div>
          </form>
        </template>
        <template slot="modal-footer" slot-scope="{ cancel }">
          <!-- Emulate built in modal footer ok and cancel button actions -->
          <b-button
            size="sm"
            variant="danger"
            @click="cancel()"
            style="display:none"
          >
            Cancel
          </b-button>
          <!-- Button with custom close trigger value -->
        </template>
      </b-modal>
  
      <!-- Available Vehicle model -->
      <b-modal  title="Available Vehicle List"
      size="xl" v-model="availablevehiclemodel" @ok="availablevehiclemodel==false" hide-footer>
	      <b-col sm="12" class="text-right">
	        <p>
	          <b
	            >Total Records :<span style="color:red;">{{
	              totalvehiclelist
	            }}</span></b
	          >
	        </p>
	      </b-col>
	        <b-table :items="available_vehiclelist" :fields="availablevehiclefields"  show-empty
                responsive
                :busy="isBusyvlist">
	          <div slot="table-busy" class="text-center text-danger my-2">
	            <b-spinner class="align-middle"></b-spinner>
	            <strong>Loading...</strong>
	          </div>
	          <template slot="drivername" slot-scope="row">
	            <span
	              >{{ row.item.driverfirstname }}
	              {{ row.item.driverlastname }}</span
	            >
	          </template>
	        </b-table>
      </b-modal>

      <!-- pending vehicle master start here-->
      <b-modal  title="Approve Registration"  size="lg" v-model="updateInfo" @ok="updateInfo==false" hide-footer class="text-center">
                  <b-row>
                    <b-col sm="12">   
                      <b-form @submit.prevent="editFreightApprovalandRejectForm('form-10','approveIncident')" data-vv-scope="form-10" class="text-center">
                            <b-row class="mb-4 text-center">
                                <div class="col-12">
                                Please Confirm the registration
                                of the below vehicle.
                                </div>
                            </b-row>
                            
                            <b-row class="mb-4">
                                <div class="col-3">
                                    <div><strong>Transporter Name</strong></div>
                                    <div>{{ updatetFreightVehicleObj.transporter_name }}</div>
                                </div>
                                <div class="col-3">
                                        <div><strong>Vehicle No</strong></div>
                                        <div>{{ updatetFreightVehicleObj.vehicle_no }}</div>
                                    </div>
                                    <div class="col-3">
                                        <div><strong>Vehicle vol. wt.</strong></div>
                                        <div>{{updatetFreightVehicleObj.vehicleweightcarrying}}</div>
                                    </div>
                                    <div class="col-3">
                                        <div><strong>Permit Of Vehicle</strong></div>
                                        <div>{{updatetFreightVehicleObj.vehicle_permit}}</div>
                                    </div>
                            </b-row>
                            <hr>
                             <b-row class="mt-3">
                              <div class="col-7">
                                <b-form-group :label-cols="4"> 
                                  <template v-slot:label>
                                    Payment Type
                                  </template>
                                  <b-form-radio-group  
                                    @change="freightUpdateWorkingDays"
                                    v-model="updatedFreight_paymenttype" 
                                    :options="[
                                        { text: 'Daily', value: 'tripend' }, 
                                        { text: 'Weekly', value: 'weekly' },
                                        { text: 'Monthly', value: 'monthly' }
                                    ]"
                                    name="paymenttype"  
                                    v-validate="'required|'" 
                                    :class="{ input: true, 'is-invalid': errors.has('form-10.paymenttype')}"
                                    :disabled="approvedLevel != 'l1'"
                                  >
                                  </b-form-radio-group>
                                  <code v-show="errors.has('form-10.paymenttype')" class="help text-danger">{{ errors.first("form-10.paymenttype") }}</code>
                                </b-form-group>
                            </div>
                            </b-row>
                            <b-row class="mb-2">
                              <div class="col-3">
                                <b-form-group label="Total Working Days*" label-align="left">
                                  <b-input-group>
                                    <b-form-input 
                                      class="input" 
                                      @change="calculateFreightCost" 
                                      type="text" 
                                      id="workingday" 
                                      name="workingday"  
                                      v-model="updatedFreight_workingdays" 
                                      placeholder="Enter Total Day"  
                                      v-validate="'required|numeric'" 
                                      :class="{ input: true, 'is-invalid': errors.has('form-10.workingday')}"
                                      disabled
                                    ></b-form-input>
                                  </b-input-group>
                                  <code v-show="errors.has('form-10.workingday')" class="help text-danger">{{ errors.first("form-10.workingday") }}</code>
                                </b-form-group>
                              </div>
                                <!-- <div class="col-3">
                                  <b-form-group label="Total Working Days*" label-align="left">
                                  <b-input-group>
{{ updatetFreightVehicleObj.workingdays }}
                                      <b-form-input class="input" @change="calculateFreightCost" type="text" id="workingday" name="workingday"  v-model="updatetFreightVehicleObj.workingdays" placeholder="Enter Total Day"  v-validate="'required|numeric'" :class="{ input: true, 'is-invalid': errors.has('form-10.workingday'),}" disabled></b-form-input>
                                  </b-input-group>
                                   <code v-show="errors.has('form-10.workingday')" class="help text-danger">{{ errors.first("form-10.workingday") }}</code>
                                  </b-form-group>
                                </div> -->

                                <div class="col-3">
                                  <b-form-group label="Fixed KM's *" label-align="left">
                                  <b-input-group>
                                      <b-form-input @change="calculateFreightCost" class="input" type="number" id="fixedkm" name="fixedkm" v-model="updatetFreightVehicleObj.fixed_kms" placeholder="Enter Fixed km's"  v-validate="'required|'" :class="{ input: true, 'is-invalid': errors.has('form-10.fixedkm'),}" :disabled="approvedLevel!='l1'" step="0.01" min="0.00"></b-form-input>
                                  </b-input-group>
                                   <code v-show="errors.has('form-10.fixedkm')" class="help text-danger">{{ errors.first("form-10.fixedkm") }}</code>
                                  </b-form-group>
                                </div>
                                <div class="col-3">
                                  <b-form-group label="Fixed Freight Rate/KM *" label-align="left">
                                  <b-input-group>
                                      <b-form-input @change="calculateFreightCost" class="input" type="number" id="fixedkmrate" name="fixedkmrate" v-model="updatetFreightVehicleObj.fixed_freightrate" placeholder="Enter Fixed rate" v-validate="'required|'" :class="{ input: true, 'is-invalid': errors.has('form-10.fixedkmrate'),}" :disabled="approvedLevel!='l1'" step="0.01" min="0.00"></b-form-input>
                                  </b-input-group>
                                  <code v-show="errors.has('form-10.fixedkmrate')" class="help text-danger">{{ errors.first("form-10.fixedkmrate") }}</code>
                                  </b-form-group>
                                </div>
                                 <div class="col-3">
                                  <b-form-group label="Fixed Freight Cost" label-align="left">
                                  <b-input-group>
                                     <b-form-input class="input" type="text" disabled 
                                          v-model="fixedFreightCost" placeholder="Enter Fixed Cost">
                                        </b-form-input>
                                  </b-input-group>
                                 
                                  </b-form-group>
                                </div>

                            </b-row>
                            <b-row class="mb-2">
                              <div class="col-3">
                                <b-form-group label="Fixed Freight Per Day" label-align="left">
                                  <b-input-group>
                                    <b-form-input class="input" type="text" disabled 
                                          v-model="fixedFreightPerDay" placeholder="Enter Fixed Per Day">
                                        </b-form-input>
                                  </b-input-group>                                 
                                </b-form-group>
                              </div>

                              <div class="col-3">
                                  <b-form-group label="Extra KM Rate *" label-align="left">
                                  <b-input-group>
                                      <b-form-input class="input" type="number" id="extrakm" name="extrakm" v-model.number="updatetFreightVehicleObj.extra_kmrate" placeholder="Enter Extra km's rate"  v-validate="'required|'" :class="{ input: true, 'is-invalid': errors.has('form-10.extrakm'),}" :disabled="approvedLevel!='l1'" step="0.01" min="0.00"></b-form-input>
                                  </b-input-group>
                                  <code v-show="errors.has('form-10.extrakm')" class="help text-danger">{{ errors.first("form-10.extrakm") }}</code>
                                  </b-form-group>
                              </div>
                              <div class="col-3">
                                  <b-form-group label="Fixed Labour Cost*" label-align="left">
                                  <b-input-group>
                                      <b-form-input class="input"  @change="calculateFreightCost" type="number" id="laborCharges" name="laborCharges" v-model="updatetFreightVehicleObj.labour_charges" placeholder="Enter Labour Charges"   v-validate="'required|'" :class="{ input: true,'is-invalid': errors.has('form-10.laborCharges'),}" :disabled="approvedLevel!='l1'" step="0.01" min="0.00"></b-form-input>
                                  </b-input-group>
                                   <code v-show="errors.has('form-10.laborCharges')" class="help text-danger">{{ errors.first("form-10.laborCharges") }}</code>
                                  </b-form-group>
                              </div>
                              <div class="col-3">
                                <b-form-group label="Fixed Labour Per Day" label-align="left">
                                  <b-input-group>
                                    <b-form-input class="input" type="text" disabled 
                                          v-model="fixedLabourPerDay" placeholder="Enter Labour Per Day">
                                        </b-form-input>
                                  </b-input-group>                                 
                                </b-form-group>
                              </div>

                                
                            </b-row>
                           
                            
                            <footer class="column has-text-center mb-4">
                              <!-- <div class="col-4">
                                  <b-form-group> <label for="paymenttype">Payment Type</label>
                                    <b-form-radio-group 
                                        v-model="updatetFreightVehicleObj.paymenttype" 
                                        v-validate="'required'"
                                        :options="[
                                            { text: 'Daily', value: 'tripend' }, 
                                            { text: 'Weekly', value: 'weekly' },
                                            { text: 'Monthly', value: 'monthly' }
                                        ]"
                                        name="paymenttype"
                                    >
                                    </b-form-radio-group>
                                </b-form-group>
                                </div>   -->
                                <!-- @click.prevent="PendingIncidentBtn(updatetFreightVehicleObj, 'approveIncident')" -->
                              <b-button variant="primary" size="md" type="submit" v-if="HideAnyAction!='Yes'">Confirm</b-button>
                              &nbsp;
                              <b-button variant="danger" size="md" @click.prevent="closePendingIncidentModal('approveIncident')">Close</b-button>
                            </footer>
                      </b-form>
                    </b-col>
                    <div id="listloader" v-if="loader">
                        <div class="listloader"></div>
                        <br/>
                       <span class="loading" style="color:#fff;">Loading...</span>
                      </div>
                  </b-row>
      </b-modal>
      <!-- pending vehicle master end here -->


      <!-- Register vehicle master start here -->
      <b-modal  title="Reject Registration"  size="lg" v-model="rejectInfo" @ok="rejectInfo==false" hide-footer class="text-center">
                  <b-row>
                    <b-col sm="12">   
                      <b-form @submit.prevent="editFreightApprovalandRejectForm('form-1','rejectIncident')" data-vv-scope="form-1" class="text-center">
                            <b-row class="mb-4 text-center">
                                <div class="col-12">
                                  Please provide a reason for rejecting the registration of below vehicle.
                                </div>
                            </b-row>
                            <b-row class="mb-5">
                                <div class="col-3">
                                    <div><strong>Transporter Name</strong></div>
                                    <div>{{ updatetFreightVehicleObj.transporter_name }}</div>
                                </div>
                                <div class="col-3">
                                        <div><strong>Vehicle No</strong></div>
                                        <div>{{ updatetFreightVehicleObj.vehicle_no }}</div>
                                    </div>
                                    <div class="col-3">
                                        <div><strong>Vehicle vol. wt.</strong></div>
                                        <div>{{updatetFreightVehicleObj.vehicleweightcarrying}}</div>
                                    </div>
                                    <div class="col-3">
                                        <div><strong>Permit Of Vehicle</strong></div>
                                        <div>{{updatetFreightVehicleObj.vehicle_permit}}</div>
                                    </div>
                            </b-row>
                            <b-row class="mb-4">
                                <div class="col-3">
                                    <strong>Reason:-</strong>
                                </div>
                                <div class="col-6">
                                <b-form-textarea
                                    id="textarea-default"
                                    placeholder="Please Enter Reason"
                                    v-model.trim="updatetFreightVehicleObj.rejectReason"
                                    maxlength="250"
                                ></b-form-textarea>
                                </div>
                            </b-row>
                            
                            <footer class="column has-text-center mb-4">
                              <!-- @click.prevent="PendingIncidentBtn(updatetFreightVehicleObj, 'rejectIncident')" -->
                              <b-button variant="primary" size="md" type="submit"  :disabled="!updatetFreightVehicleObj.rejectReason" v-if="HideAnyAction!='Yes'">Confirm</b-button>
                              &nbsp;
                              <b-button variant="danger" size="md" type="submit" @click.prevent="closePendingIncidentModal('rejectIncident')">Close</b-button>
                            </footer>
                      </b-form>
                    </b-col>
                  </b-row>
                </b-modal>
                <!-- Register vehicle master end here -->
                 <!-- Transporter Log Popup Modal -->
        <b-modal ref="transporterLogModal" title="Vehicle Log Details" hide-footer  size="xl">
          <div id="listloader" v-if="loader">
              <div class="listloader"></div>
              <br/>
              <span class="loading" style="color:#fff;">Loading...</span>
            </div>
            <div>
              <table class="table table-bordered mt-3">
                <thead>
                  <tr>
                    <th>           
                    Sr.no
                    </th>
                    <th>ID</th>
                    <th>Transporter ID</th>
                    <th>Vehicle ID</th>
                    <th>Status</th>
                    <th>Createdby</th>
                    
                    <th> User Approval Level</th>
                      <th>Total Approval Levels</th>
                      <th>Reject Reason</th>
                    <th>Created Date</th>
                  </tr>
                </thead>
                <tbody v-if="arrTransporterLog.length > 0">
                  <tr v-for="(item, index) in arrTransporterLog" :key="index">
                    <td>{{(index+1)}}</td>
                    <td>{{ item.id }}</td>
                    <td>{{ item.transporter_id }}</td>
                    <td>{{ item.vehicle_id }}</td>
                    <td>{{ item.status }}</td>
                    <td>{{ item.createdby }}</td>
                    <td>{{ item.user_approval_level }}</td>
                    <td>{{ item.total_approval_levels }}</td>
                    <td>{{ item.reject_reason }}</td>
                    <td>{{ formatDate(item.createdat) }}</td>
                  </tr>
                </tbody>
                <tbody v-else>
                  <tr>
                    <td colspan="8">Records Not Created By Transporter</td>
                  </tr>
                </tbody>
              </table>
            </div>    
            <!-- Footer with Approve and Reject with Remark Buttons -->
            <div class="text-right mt-3"  v-if="arrTransporterLog.length > 0">    
              <b-button variant="secondary" @click="$refs.transporterLogModal.hide()">Close</b-button>
            </div>    
        </b-modal>

    </div>
  </template>
  
  <script>
  import CONSTANTS from "@/utils/constants";
  import Utils from "@/utils";
  import auth from "@/utils/auth";
  const axios = require('axios')

  export default {
    data: function() {
      return {
        loader:false,
        selectedApprovalLevel: "",
        name: "deliveryagentmaster",
        isBusy: false,

        totalCount: 0, 
        currentPage: 1, // Current page
        perPage: 100,
  
        customer: {
          workingdays: 0,
      },

        // selected:'',
        seen: true,
        searchObj: {},
  
        resetPassword: false,
        editAgentMaster: false,
        toggleInfo: false,
  
        bordered: true,
        items: [],
        searchResults: [],
  
        searchResults1: [],
        fields: [
          {
            key: "vehicle_id",
            label: "Vehicle Id",
            sortable: true,
            sortDirection: "desc",
          },
          {
            key: "drivername",
            label: "Driver Name",
            sortable: true,
            sortDirection: "desc",
          },
          {
            key: "drivermobilenumber",
            label: "Driver Mobile No",
            sortable: true,
            sortDirection: "desc",
          },
          { key: "vehicle_name", label: "Vehicle Name", sortable: true },

          { key: "vehicle_no", label: "Vehicle Number", sortable: true },
          { key: "vehicle_origin", label: "Vehicle Origin City", sortable: true },
          { key: "transportername", label: "Transporter Name", sortable: true },
          { key: "paymenttype", label: "Payment Type", sortable: true },
          {
            key: "vehicleweightcarrying",
            label: "Volumetric Weight",
            sortable: true,
          },
        { key: "vehicle_type", label: "Vehicle Type", sortable: true },
          { key: "isactive", label: "is Active", sortable: true },
          
        //   {
        //     key: "vehiclephysicalweight",
        //     label: "Physical Weight",
        //     sortable: true,
        //   },
           { key: "invoice_status", label: "Approval Status", sortable: true },
                   { key: "no_of_levels", label: "No Of Levels" },

          { key: "createddate", label: "Created Date", sortable: true },
  
          { key: "actions", label: "Actions" },
        ],
        userType: "",
  
        totalRows: 0,
        currentPage: 1,
        // perPage:20,
        pageOptions: [5, 10, 15],
        sortBy: null,
        sortDesc: true,
        sortDirection: "desc",
        vehiclefilter:'',
        vehicleCityWHmodal: false,
        cityData: [],
        adminData: [],
        userType: "",
        showSelectAll: true,
        valueAdmin: [],
        optionsAdmin: [],
        adminSysid: [],
        sysIdinlist: "",
        fieldAdmin: { text: "name", value: "id" },
        vehicle_Id: "",
        sysIdinlist: "",
        sysusermasterid: "",
        searchvaluesarr: [],
        avilablevehicle : "",
        availablevehiclemodel : false,
        available_vehiclelist : [],
        totalvehiclelist : 0,
        isBusyvlist : false,
        availablevehiclefields : [
          // { key: "vehicle_id", label: "Vehicle Id", sortable: true,
          //   sortDirection: "desc",},
          { key: "vehicle_no", label: "Vehicle Number", sortable: true },
  
          { key: "drivername", label: "Driver Name", sortable: true, sortDirection: "desc" },
  
          { key: "drivermobilenumber", label: "Driver Mobile No", sortable: true, sortDirection: "desc" },
  
          { key: "vehicle_name", label: "Vehicle Name", sortable: true },
  
          // { key: "vehicle_no", label: "Vehicle Number", sortable: true },
  
          { key: "vehicleweightcarrying", label: "Volumetric Weight",
            sortable: true},
  
          { key: "vehiclephysicalweight", label: "Physical Weight",
            sortable: true},
  
          { key: "createddate", label: "Created Date", sortable: true },
        ],
        sendadminid : [],
        adminWHid: [],
        warehouseData: [],
        warehouseAdmin: [],
        valueWHAdmin :[],
        fieldwhAdmin: { text: "name_wh", value: "id_wh" },
        WHid :'',
        helper_data :[],
        transporter_id:null,
        mailitems :[],
        optionmailid :[],
        transporterCompanyName:null,
        errors_GST:false,
        errors_showGST:{},
        removeGST:false,
        showverifybutton : false,
        driver_data:[],
  
        vehicleNameOptions:[],
        vehicleTypeSizeOptions:[],
        fuelTypeOptions:[],
        vehiclenametext:false,
        vehicletypesizetext:false,
        vehiclenameflag:false,
        vehicleName_id:null,
        vehicleTypeSize_id:null,
        fuelType_id:null,
        updatetFreightVehicleObj :{
        },
        rejectInfo: false,
        addInfoCard:false,
        updateInfo:false,
        accessBody:[],
      isReadOnly:false,
      arrTransporterLog:[],

      selectedBankCheque: '',
      pincodes: [],
      pincodeCityData: [],
      bankFileName: '',
      bankcancelledcheque: '',
      bankFileType: '',
      selectedGstinCertficate: '',
      gstincertificate: '',
      gstinCertficateType: '',
      gstinCertficateFilename: '',
      approveAction:[],
      approvedLevel:'',
      tripLevelInvoiceApproval: null,
      tripLevelInvoiceApprovalLevel:'',
      adminHub:{},
      optionHubid:[],
      hubList:[],
      dlFileName: '',
      dlFileType: '',
      selectedDl: '',
      licence_url: '',
      pucFileUplodFilename: '',
      pucFileUplod: '',
      pucFileUplodType: '',
      puc_url: '',
      selectedRegistration: '',
      registrationFilename: '',
      registrationFileType: '',
      registration_url: '',
      selectedPermit: '',
      permitFileName: '',
      permitFileType: '',
      permit_url: '',
      selectedInsuranceFile: '',
      insurance_url: '',
      fixedFreightCost:'',
      fixedFreightPerDay:'',
      fixedLabourPerDay:'',
      fixedFreightCostEdit:'',
      fixedFreightPerDayEdit:'',
      fixedLabourPerDayEdit:'',

      // shamal
      updatedFreight_workingdays:0,

      updatedFreight_paymenttype: '',

      };
    },
    created: function() {
      var userdata = localStorage.getItem("userData");
      var userInfo = JSON.parse(userdata);
      this.userType = userInfo.user_type;

      this.user_id = userInfo.sysusermasterid;
      this.accessBody = userInfo.body;
      console.log('userInfouserInfouserInfouserInfo',userInfo);
      if (userdata && userInfo.approval_action && userInfo.approval_action!='') {
        this.tripLevelInvoiceApproval = userInfo.approval_action.find(action => action.module === "vehicle_freight_charges");
        // Log the result (or handle it as needed)
        if (this.tripLevelInvoiceApproval && this.tripLevelInvoiceApproval.level) {
          this.tripLevelInvoiceApprovalLevel = this.tripLevelInvoiceApproval.level.replace('l', '');
          this.selectedApprovalLevel=this.tripLevelInvoiceApprovalLevel;
        }
        console.log('tripLevelInvoiceApproval Level',this.tripLevelInvoiceApprovalLevel);
      }
      var approval_action = localStorage.getItem("approval_action");
      if (approval_action) {
          var approval_actionInfo = JSON.parse(approval_action);
          this.approveAction = approval_actionInfo; 
          this.getapprovedActionUser()
        }

      this.ischeckbodyvalidation();
      this.getPincodeList();
      this.displaydata();
      this.getVehicleDetailsList();
      
    },
    props:['HideAnyAction','vehicleidDetails'],
    computed: {
    
      sortOptions() {
        // Create an options list from our fields
        return this.fields
          .filter((f) => f.sortable)
          .map((f) => {
            return { text: f.label, value: f.key };
          });
      },
    },
  
    mounted: function() {
     this.$watch('customer.workingdays', (newVal) => {
      console.log('Working days updated to:', newVal);
      this.$set(this.customer, 'workingdays1', newVal);
    });
    },
  
    methods: {

  //   freightUpdateWorkingDays(newValue) {
  //     console.log("===================",newValue)
  //       let value = 0;
  //       if (newValue === 'tripend') {
  //         value = 1;
  //       } else if (newValue === 'weekly') {
  //         value = 7;
  //       } else if (newValue === 'monthly') {
  //         value = 31;
  //       }
  //       this.updatetFreightVehicleObj.workingdays = value;
  //       // this.$set(this.updatetFreightVehicleObj, 'workingdays1', value); // Force Vue to reactively update
  //       this.$set(this.updatetFreightVehicleObj, 'workingdays', value); 
  //       console.log('Updated Working Days:', this.updatetFreightVehicleObj.workingdays);
  //       this.calculateFreightCost();
  //  },
   
  freightUpdateWorkingDays(newValue) {
      console.log("===================", newValue);
      let value = 0;
      if (newValue === 'tripend') {
        value = 1;
      } else if (newValue === 'weekly') {
        value = 7;
      } else if (newValue === 'monthly') {
        value = 31;
      }

      this.updatedFreight_workingdays = value;  // Update workingdays
      console.log('Updated Working Days:', this.updatedFreight_workingdays);
      // this.calculateFreightCost();
    },

   updateWorkingDays(newValue) {
        let value = 0;
        if (newValue === 'tripend') {
          value = 1;
        } else if (newValue === 'weekly') {
          value = 7;
        } else if (newValue === 'monthly') {
          value = 31;
        }
        this.$set(this.customer, 'workingdays1', value); // Force Vue to reactively update
        this.$set(this.customer, 'workingdays', value); 
        console.log('Updated Working Days:', this.customer.workingdays1);
        this.calculateFreightCostEdit();
   },
   calculateFreightCost() {
   let workingdays =this.updatedFreight_workingdays || 0;
   let labourCharges =this.updatetFreightVehicleObj.labour_charges || 0;

  //  console.log('ssssssssss',this.updatetFreightVehicleObj.fixed_kms);
    let kms = parseFloat(this.updatetFreightVehicleObj.fixed_kms) || 0;
    let rate = parseFloat(this.updatetFreightVehicleObj.fixed_freightrate) || 0;
    this.fixedFreightCost = (kms * rate).toFixed(2);
    this.fixedFreightPerDay = this.fixedFreightCost ? parseFloat((this.fixedFreightCost / workingdays).toFixed(2)): 0;
    this.fixedLabourPerDay= labourCharges ? parseFloat((labourCharges / workingdays).toFixed(2)): 0;
    // console.log('ssssssssss-fixed_freightcost',this.fixedFreightCost);

  },
  calculateFreightCostEdit() {
      let workingdaysEdit =this.customer.workingdays || 0;
      console.log('calculateFreightCostEdit',workingdaysEdit);
      let labourChargesEdit =this.customer.labour_charges || 0;
      let kms = parseFloat(this.customer.fixed_kms) || 0;
      let rate = parseFloat(this.customer.fixed_freightrate) || 0;
      
      this.fixedFreightCostEdit = (kms * rate).toFixed(2);
      this.fixedFreightPerDayEdit = (this.fixedFreightCostEdit && this.fixedFreightCostEdit!='0.00') ? parseFloat((this.fixedFreightCostEdit / workingdaysEdit).toFixed(2)): 0;
      this.fixedLabourPerDayEdit= labourChargesEdit ? parseFloat((labourChargesEdit/workingdaysEdit).toFixed(2)): 0;
  },
     formatDate(date) {
      if (!date) return 'N/A'; // Fallback if date is null or undefined
      const parsedDate = new Date(date);
      return parsedDate.toLocaleDateString('en-US', {
        year: 'numeric',
        month: '2-digit',
        day: '2-digit'
      });
    },
    transporterMasterLog(transporter_id,vehicle_id) {   
      console.log('transporterMasterLog',transporter_id);
      this.remark = '';
       this.loader = true;
      const obj = {
        transporterId: transporter_id,
        type:'vehicle',
        vehicleId:vehicle_id,
      };
      console.log('-------transporterMasterLog-------',obj);

      this.$http.post(`${CONSTANTS.MISREPORT_API_URL}/getTransporterMasterLog`, obj).then(result => {
        console.log('getTransporterMasterLog',result.body);
         this.loader = false;
        if (result.body.returnstatus === 'Successful') {
          this.arrTransporterLog = result.body.returnvalue;
        } else {
          this.arrTransporterLog = [];
        }
      }).catch(ex => {
        console.error('Error fetching invoice list:', ex);
      }).finally(() => {
        this.loader = false;
      });

      // Show dispute confirmation modal
      this.$refs.transporterLogModal.show();
    },
    	getapprovedActionUser(){
	       for (var i = 0; i < this.approveAction.length; i++) {
	         this.approveAction[i]
	         console.log("====================",this.approveAction[i].module)
	         if(this.approveAction[i].module==='vehicle_freight_charges'){
	           this.approvedLevel = this.approveAction[i].level;
	         }
	       }
      },

      ischeckbodyvalidation(){
            for (let i = 0; i < this.accessBody.length; i++) {
                const element = this.accessBody[i];
            
                // if (element.title=='Vehicle Master' && element.isReadonly==true && this.route_id=='normal') {
                //   this.isReadOnly=true
                // }
            if (element.child) {
                for (let j = 0; j < element.child.length; j++) {
                const k = element.child[j];
                if (k.title=='Vehicle Master' && k.isReadonly==true) {
                    this.isReadOnly=true
                }
                }
            }
            }
            console.log(" this.isReadOnly", this.isReadOnly)
        },
      downloadvehiclereport(){
        document.getElementById("overlay").style.display = "block";
         var userdata = localStorage.getItem('userData')
        var userInfo = JSON.parse(userdata)
            var csvObj = {
              sysusermasterid:`${userInfo.sysusermasterid}`,
              usertype:`${userInfo.user_type}`,
               approver_status: 'freight_pending',
               tripLevelInvoiceApprovalLevel: this.tripLevelInvoiceApprovalLevel,
              vehicle_id: this.HideAnyAction=='Yes'?this.vehicleidDetails:'',
             };
              console.log("JJJJJ",csvObj);
          // console.log("csvObj",csvObj);
          this.$http.post(`${CONSTANTS.MISREPORT_API_URL}/getCSVForVehicleMaster`, csvObj)
            .then(result => {
              
            document.getElementById("overlay").style.display = "none";
             if(result.body=="success")
           {
           // alert("Please Check Ur Mail For Downlod Link")
           this.$fire({
                    text:"Please Check Your Mail For Downlod Link",
                    type: "success",
                    timer: 30000
                  }); 
         }
         else
         {
          this.$fire({
                    text:"Can not Download",
                    type: "error",
                    timer: 30000
                  }); 
         }
  
            })
            .catch(ex => {
              console.log("error-----", ex);
            });
      },
       handleFilterChange() {
        console.log("Selected Approval Level:", this.selectedApprovalLevel);
        this.tripLevelInvoiceApprovalLevel=this.selectedApprovalLevel;
        this.displaydata();
      },
      displaydata: function(page = this.currentPage) {
        // alert("innnn");
        this.items = [];
        this.currentPage = page; // Update current page
        this.totalRows =0;
        this.isBusy = true;
        var userdata = localStorage.getItem("userData");
        var userInfo = JSON.parse(userdata);
        const deliveryagentobj = {
        page: this.currentPage, 
          pageSize: this.perPage,
        //   sysusermasterid: `${userInfo.sysusermasterid}`,
          usertype: `${userInfo.user_type}`,
          approver_status: 'freight_pending',
          tripLevelInvoiceApprovalLevel:this.tripLevelInvoiceApprovalLevel,
          vehicle_id: this.HideAnyAction=='Yes'?this.vehicleidDetails:'',
          vehiclefilter: this.vehiclefilter,

        };
        console.log("deliveryagentobj", deliveryagentobj);
        this.$http
          .post(
            `${CONSTANTS.MIGRATION_API_URL}/getVehiclesBasedOnStatus`,
            deliveryagentobj
          )
          .then((result) => {
            console.log("YYY", result);
            this.isBusy = false;
             if (result.body.returnmsg==='Successful') {
             this.data = result.body.returnvalue;
  
              this.items = result.body.returnvalue;
  
             // this.totalRows = result.body.returnvalue.length;
              this.totalCount = result.body.returnvalue[0].totalcount1;
              this.totalRows = result.body.returnvalue[0].totalcount1;

              // this.totalCount = result.body.totalcount;
              // this.totalRows = result.body.totalcount;

            } else {
              this.data = [];
              this.items = []
              this.totalRows = 0;
              this.totalCount =0;
            }

          })
          .catch((ex) => {
            console.log("error", ex);
          });
      },
  
      addVehicleName:function(){
        this.customer.vehiclenametext='';
        if(this.customer.vehiclename.label=='Other'){
          this.vehiclenametext=true;
        }
        else{
          this.vehiclenametext=false;
        }
      },
  
      addVehicleTypeSize:function(){
        this.customer.vehicletypesizetext='';
        if(this.customer.vehicletypesize.label=='Other'){
          this.vehicletypesizetext=true;
        }
        else{
          this.vehicletypesizetext=false;
        }
      },
  
      searchInLoadManagement() {
        this.searchvaluesarr = [];
        this.searchvaluesarr.push(this.vehiclefilter);
        console.log("YYY", this.searchvaluesarr);
        this.displaydata();
      },
  
      clearSearch() {
        this.vehiclefilter = "";
        this.displaydata();
      },

 
      validateForm4(scope) {
        this.$validator.validateAll(scope).then((result) => {
          if (result) {
            this.changeVehiclePassword();
          }
        });
      },
  
      validateForm5(scope) {
        this.$validator.validateAll(scope).then((result) => {
          console.log('result==============',result);
          
          if (result) {
            this.updateDeliveryAgent();
          } else {
          // Validation failed
          console.log("Validation failed!");
          // Optionally, highlight errors or show messages
          console.log("Validation errors:", this.errors.items);
        }
        });
      },
  
      changeVehiclePassword: function() {
        document.getElementById("overlayModal").style.display = "block";
        var userdata = localStorage.getItem("userData");
        var userInfo = JSON.parse(userdata);
        console.log("this.vehicle_id", this.vehicle_id);
        const encryptedText = btoa(this.vehicle_id);
  
        console.log("encryptedText", encryptedText);
        const decryptedText = atob(encryptedText);
        console.log("decryptedText", decryptedText);
        var passwObj = {
          vehicle_id: encryptedText,
          password: this.customer.deliveryagentpassword.trim(),
        };
        this.$http
          .post(
            `${CONSTANTS.MIGRATION_API_URL}/changeVehicleUserPassword`,
            passwObj
          )
          .then((result) => {
            // console.log("error",result);
            document.getElementById("overlayModal").style.display = "none";
            if (result.body.returnmsg == "Successful") {
              this.$fire({
                text: "Password Updated Successfully",
                type: "success",
                timer: 300000,
              });
  
              this.resetPassword = false;
              this.customer = {};
              this.displaydata();
            } else {
              this.$fire({
                text: result.body.returnvalue,
                type: "error",
                timer: 300000,
              });
            }
          })
          .catch((ex) => {
            console.log("error", ex);
          });
      },
  
      cancel: function() {
        this.customer = {};
        this.editAgentMastertoggleInfo = !this.editAgentMastertoggleInfo;
      },
  
      editcancel: function() {
        this.customer = {};
        this.editAgentMaster = !this.editAgentMaster;
      },
  

      adminWiseHubList(hub_id){
            var userdata = localStorage.getItem("userData");
            var userInfo = JSON.parse(userdata);
             //let sysId = this.valueAdmin.toString().split(",");
            let obj = {
               //  sysusermasterid:sysId
            }

            this.$http.post(`${CONSTANTS.MISREPORT_API_URL}/getAdminHubListingNew`,obj)
            .then(result => {
                if(result.body.returnmsg === "Successful"){
                this.hubList  = result.body.returnvalue;
                var data = [];
                let newObj={};
                this.hubList.forEach(function (srData) {
                  if(hub_id==srData.hubid){
                    newObj={
                    key:srData.hubid,
                    label:srData.hubname + '-' + srData.hubid
                    };
                  }
                    data.push({
                    key:srData.hubid,
                    label:srData.hubname + '-' + srData.hubid
                    });
                });
                this.optionHubid = data;
                console.log('---------------------',newObj)
                this.adminHub=newObj;
                }
                else{
                  this.hubList=[];
                  this.optionHubid = [];
                }

            }).catch(ex => {
              console.log('error', ex)
            })
        },
      getVehicleDetailsList:function(){
        var userdata = localStorage.getItem("userData");
        var userInfo = JSON.parse(userdata);
  
        const Obj={
  
        }
  
        this.$http.post(`${CONSTANTS.MIGRATION_API_URL}/getVehicleDetailsList`, Obj)
        .then((result)=>{
          if(result.body && result.body.returnmsg== "Successful"){
            var vehicleNameData=result.body.returnvalue[0].vehicle_name;
            var vehicleTypeSizeData=result.body.returnvalue[0].vehicle_type;
            var fuelTypeData=result.body.returnvalue[0].fuel_Type;
                      
            for(let i=0;i<vehicleNameData.length;++i){
              this.vehicleNameOptions.push({
                key:vehicleNameData[i].id,
                label:vehicleNameData[i].value
              })
              if(i==vehicleNameData.length-1){
                this.vehicleNameOptions.push({
                  label:'Other'
               })
              }
            }  
            // console.log("vehicle Name Options-->",this.vehicleNameOptions)              
  
            for(let i=0;i<vehicleTypeSizeData.length;++i){
              this.vehicleTypeSizeOptions.push({
                key:vehicleTypeSizeData[i].id,
                label:vehicleTypeSizeData[i].value
              })
              if(i==vehicleTypeSizeData.length-1){
                this.vehicleTypeSizeOptions.push({
                  label:'Other'
                })
              }
            }
            // console.log("vehicle Type Size Options-->",this.vehicleTypeSizeOptions) 
  
            for(let i=0;i<fuelTypeData.length;++i){
              this.fuelTypeOptions.push({
                key:fuelTypeData[i].id,
                label:fuelTypeData[i].value
              })
            }
            // console.log("fuel Type Options-->",this.fuelTypeOptions) 
          }
          else{
            this.vehicleNameOptions=[];
            this.vehicleTypeSizeOptions=[];
            this.fuelTypeOptions=[];
          }
        })
        .catch((ex) => {
          console.log("error", ex);
        });
      },
  
      updateDeliveryAgent: function() {
      console.log('updateDeliveryAgentupdateDeliveryAgentupdateDeliveryAgentupdateDeliveryAgent');
        document.getElementById("overlayModal").style.display = "block";
        var result = [];
        // alert("innnn");
        var userdata = localStorage.getItem("userData");
        var userInfo = JSON.parse(userdata);
        var sysusermasteridinput = userInfo.sysusermasterid;

        if (this.customer.altmobile_no == this.customer.mobile_no) {
          // alert("Alternate Mobile Number should be different from Mobile Number");
          this.$fire({
            text:
              "For Driver Alternate Mobile Number should be different from Mobile Number",
            type: "warning",
            timer: 30000,
          });
          document.getElementById("overlayModal").style.display = "none";

          return false;
        }
  
        if (this.customer.helperaltmobilenumber == this.customer.helpermobilenumber) {
          // alert("Alternate Mobile Number should be different from Mobile Number");
          this.$fire({
            text:
              "For Helper Alternate Mobile Number should be different from Mobile Number",
            type: "warning",
            timer: 30000,
          });
          document.getElementById("overlayModal").style.display = "none";

          return false;
        }
  
           if(this.transporterCompanyName==null){
            document.getElementById("overlayModal").style.display = "none";
            this.$fire({
            text:"Please Select Transporter Company",
            type: "warning",
            timer: 30000,
            });
            document.getElementById("overlayModal").style.display = "none";

            return false;  
           }
  
          if(this.customer.driver_contracter_name == null || this.customer.contractormobilenumber == null || this.customer.contracter_emailid ==null){
            document.getElementById("overlayModal").style.display = "none";
            this.$fire({
              text:"Please Add Transporter Details From Transporter Master",
              type: "warning",
              timer: 30000,
            });
            document.getElementById("overlayModal").style.display = "none";

            return false; 
          }
          if (this.customer.vehiclenametext =='Other' || this.customer.vehiclenametext =='other') {
          document.getElementById("overlayModal").style.display = "none";
          this.$fire({
            text: "Please Add New Vehicle Name",
            type: "warning",
            timer: 30000,
          });
          document.getElementById("overlayModal").style.display = "none";

          return false;
        }
           this.driver_data.push({
              driverfirstname: this.customer.driverfirstname.trim(),
              driverlastname: this.customer.driverlastname.trim(),
              drivermobilenumber: this.customer.mobile_no.trim(),
              driveraltmobilenumber: this.customer.altmobile_no.trim(),
              driving_license: this.customer.driving_license.trim(),
              driver_license_photo:'',
              driver_license_criteria:'',
              driver_email:'',                
              driver_adhar_no:'',
              driver_emergency_no:'',
              driver_adhar_photo:'',
              driver_language:[],
              driver_qualification:[]
            });
          this.helper_data.push({
              helperfirstname: this.customer.helperfirstname.trim(),
              helperlastname: this.customer.helperlastname.trim(),
              helpermobilenumber: this.customer.helpermobilenumber.trim(),
              helperaltmobilenumber: this.customer.helperaltmobilenumber.trim(),
              helper_license_number:"",
              helper_license_photo:"",
              helper_license_criteria:"",
              helper_email:"",
              helper_adhar_no:"",
              helper_adhar_photo:""
          });
                  // console.log("this.helper_data",this.helper_data);
        var passwObj = {
          sysusermasterid:sysusermasteridinput,
          vehicleid: `${this.customer.vehicleMasterid}`,
          vehicleno: this.customer.editvehicleno.trim(),
          lastmodifiedby: `${userInfo.sysemailid.trim()}`,
          driverfirstname: this.customer.driverfirstname.trim(),
          driverlastname: this.customer.driverlastname.trim(),
          drivermobilenumber: this.customer.mobile_no.trim(),
          driveraltmobilenumber: this.customer.altmobile_no.trim(),
          //vehiclename: this.customer.vehiclename.trim(),
          //vehiclename: this.vehiclenametext == false ? this.customer.vehiclename.key : this.customer.vehiclenametext.trim(), 
          vehiclename: this.vehiclenametext == false ? this.customer.vehiclename.key == '' || this.customer.vehiclename.key == null || this.customer.vehiclename.key == undefined || this.customer.vehiclename.key == 'null' || this.customer.vehiclename.key == 'undefined' ? this.vehicleName_id : this.customer.vehiclename.key : this.customer.vehiclenametext.trim(),
          fueltype: this.customer.fueltype.key == '' || this.customer.fueltype.key == null || this.customer.fueltype.key == undefined || this.customer.fueltype.key == 'null' || this.customer.fueltype.key == 'undefined' ? this.fuelType_id : this.customer.fueltype.key,
          // vehicleno_prefix:`${this.customer.vehicleno_prefix}`,
  
          driving_license: `${this.customer.driving_license.trim()}`,
          // driver_contracter_name:`${this.customer.driver_contracter_name}`,
          // contracter_emailid: `${this.customer.contracter_emailid}`,
          vehicletype: this.customer.vehicletype.trim(),
          vehicletypesize: this.vehicletypesizetext==false ? this.customer.vehicletypesize.key == '' || this.customer.vehicletypesize.key == null || this.customer.vehicletypesize.key == undefined || this.customer.vehicletypesize.key == 'null' || this.customer.vehicletypesize.key == 'undefined' ? this.vehicleTypeSize_id : this.customer.vehicletypesize.key:this.customer.vehicletypesizetext.trim()+"ft",
          registration_no : this.customer.registration_no.trim(),
          //vehiclemake: this.customer.vehiclemake.trim(),
          vehicleweightcarrying: this.customer.vehicleweightcarrying.trim(),
          vehiclephysicalweight: this.customer.vehiclephysicalweight.trim(),
          // vehicledimensionsweight :this.customer.vehicledimensionsweight.trim(),
          // editvehicleno:this.customer.editvehicleno,
          contractormobilenumber: this.customer.contractormobilenumber!=null || this.customer.contractormobilenumber!=undefined || this.customer.contractormobilenumber !="" ? this.customer.contractormobilenumber.trim():'',
          helperfirstname: this.customer.helperfirstname.trim(),
          helperlastname: this.customer.helperlastname.trim(),
          helpermobilenumber: this.customer.helpermobilenumber.trim(),
          helperaltmobilenumber: this.customer.helperaltmobilenumber.trim(),
          // drivercontractername: this.customer.driver_contracter_name.trim(),
          drivercontractername: this.customer.driver_contracter_name!=null || this.customer.driver_contracter_name!=undefined || this.customer.driver_contracter_name !=""?this.customer.driver_contracter_name.trim():'',
          contracter_emailid:this.customer.contracter_emailid!=null || this.customer.contracter_emailid!=undefined || this.customer.contracter_emailid !="" ? this.customer.contracter_emailid.trim():'',
          transporter_id :  this.transporterCompanyName.key=='' || this.transporterCompanyName.key == null || this.transporterCompanyName.key == undefined || this.transporterCompanyName.key == 'null' || this.transporterCompanyName.key == 'undefined' ? this.transporter_id:this.transporterCompanyName.key,
          helper_data:this.helper_data,
          transporter_company_name:this.transporterCompanyName.label?this.transporterCompanyName.label.trim():this.transporterCompanyName.trim(),
          transporter_gstnumber:`${this.customer.transporter_gstnumber==null || this.customer.transporter_gstnumber==undefined || this.customer.transporter_gstnumber==''?'':this.customer.transporter_gstnumber.trim()}`,
          driver_data:this.driver_data,

          pincode: this.customer.pincode ? this.customer.pincode : '',
          address: this.customer.address ? this.customer.address : '',
          city: this.customer.city ? this.customer.city : '',
          state: this.customer.state ? this.customer.state : '',
          pan: this.customer.pan ? this.customer.pan : '',
          bankname: this.customer.bankname ? this.customer.bankname : '',
          bankaccountname: this.customer.bankaccountname ? this.customer.bankaccountname : '',
          branchname: this.customer.branchname ? this.customer.branchname  : '',
          accountnumber: this.customer.accountnumber ? this.customer.accountnumber : '',
          ifsccode: this.customer.ifsccode ? this.customer.ifsccode : '',
          aadhar: this.customer.aadhar? this.customer.aadhar : '',
          vendortype: this.customer.vendortype ? this.customer.vendortype : '',
          bankcancelledcheque: this.customer.bankcancelledcheque ? this.customer.bankcancelledcheque : '',
          gstincertificate: this.gstincertificate ? this.gstincertificate : '',
          hubid:userInfo.user_type=='2'?userInfo.hub_id:(this.adminHub?this.adminHub.key:""),
          usertype:userInfo.user_type,
          sysusermasterid:[`${userInfo.sysusermasterid}`],
          labour_charges: this.customer.labour_charges ? this.customer.labour_charges : null,
          fixed_kms: this.customer.fixed_kms ? `${this.customer.fixed_kms}` : null,
          fixed_freightrate: this.customer.fixed_freightrate ? this.customer.fixed_freightrate : null,
          extra_kmrate: this.customer.extra_kmrate ? this.customer.extra_kmrate : null,
          workingdays: this.customer.workingdays ? this.customer.workingdays : null,
          puc_url:this.customer.puc_url ? this.customer.puc_url:null,
          insurance_url:this.customer.insurance_url ?this.customer.insurance_url:null,
          registration_url:this.customer.registration_url ?this.customer.registration_url:null,
          permit_url:this.customer.permit_url ?this.customer.permit_url:null,
          paymenttype: this.customer.paymenttype ? this.customer.paymenttype : ''

        };
        passwObj.vehicletypesize = passwObj.vehicletypesize;
        // return false;
        // if (typeof this.customer.deliveryagentmasterid !== "undefined") {
        //DAUpdateVehicleDetail
        this.$http
          .post(`${CONSTANTS.MIGRATION_API_URL}/updatevehicledetailsNew`, passwObj)
          .then((result) => {
            document.getElementById("overlayModal").style.display = "none";
            if (result.body.returnmsg === "Successful") {
              // alert("Updated Successfully");
              this.$fire({
                text: "Updated Successfully",
                type: "success",
                timer: 30000,
              });
  
              this.customer = {};
              this.displaydata();
              this.editAgentMaster = !this.editAgentMaster;
              this.vehicleNameOptions=[];
              this.vehicleTypeSizeOptions=[];
              this.fuelTypeOptions=[];
              this.getVehicleDetailsList();
            } else {
              this.$fire({
                text: result.body.returnvalue,
                type: "error",
                timer: 300000,
              });
            }
          })
          .catch((ex) => {
            console.log("error", ex);
          });
      },
  
      editvehicleCityWH: function(value) {
        console.log("Value",value);
        var userdata = localStorage.getItem("userData");
        var userInfo = JSON.parse(userdata);
        this.valueAdmin = [];
        this.optionsAdmin = [];
        this.warehouseData = [];
          this.warehouseAdmin = [];
          this.valueWHAdmin=[];
          this.vehicleCityWHmodal = true;
        this.vehicle_Id = value.vehicle_id;
        this.sysIdinlist = value.sysusermasterid;
        this.WHid = value.warehouseid;
        // console.log("this.vehicle_Id=value.vehicle_id;",this.sysIdinlist);
        this.vehicle_Id = value.vehicle_id;
  
        if (this.WHid !=null) {
          this.adminWHid = this.WHid.split(",");
          console.log("YYYYYYYYYY", this.adminWHid);
          for (let i = 0; i < this.adminWHid.length; i++) {
            this.valueWHAdmin.push(this.adminWHid[i]);
          }
          console.log("this.valueWHAdmin",this.valueWHAdmin)
        }
        if (this.sysIdinlist != null) {
          this.adminSysid = value.sysusermasterid.split(",");
          // console.log("YYYYYYYYYY", this.adminSysid);
          for (let i = 0; i < this.adminSysid.length; i++) {
            this.valueAdmin.push(this.adminSysid[i]);
          }
        }
  
        const Obj = {
          sysusermasterid: `${userInfo.sysusermasterid}`,
          usertype: `${userInfo.user_type}`,
        };
        console.log("Obj", Obj);
        this.$http
          .post(`${CONSTANTS.MIGRATION_API_URL}/adminListingForVehicle`, Obj)
          .then((result) => {
            console.log("YYY", result);
            if (result.body.returnmsg === "Successful") {
              this.adminData = result.body.returnvalue;
              for (let i = 0; i < this.adminData.length; i++) {
                let admin = {
                  name:
                    this.adminData[i].userfirstname +
                    "" +
                    this.adminData[i].userlastname +
                    " - " +
                    (this.adminData[i].user_type == 2 ? "Admin" : "Super Admin"),
                  id: this.adminData[i].sysusermasterid.toString(),
                };
  
                this.optionsAdmin.push(admin);
                // console.log("HHHHAAAA",this.optionsAdmin);
              }
              // console.log(this.optionsAdmin);
            } else {
              this.adminData = result.body.returnvalue;
            }
          })
          .catch((ex) => {
            console.log("error", ex);
          });
      },
      
      selectAdmin: function() {
        this.valueAdmin;
        this.valueAdmin.toString();
        this.editWiseWarehouseList();
             
      },
  
      editWiseWarehouseList: function() {
        this.sendadminid = this.valueAdmin.toString().split(",");
  
        // if (this.valueAdmin != null) {
        //   this.adminWHid = this.WHid.split(",");
        //   console.log("YYYYYYYYYY", this.adminWHid);
        //   for (let i = 0; i < this.adminWHid.length; i++) {
        //     this.valueWHAdmin.push(this.adminWHid[i]);
        //   }
        //   console.log("this.valueWHAdmin",this.valueWHAdmin)
        // }
       
  
        if (this.valueAdmin.length>0) {
          
          const Obj = {
            sysusermasterid:  this.sendadminid,
          };
          console.log("Obj", Obj);
          
          this.$http.post(`${CONSTANTS.MIGRATION_API_URL}/getAdminWiseWarehouseList`, Obj)
          .then((result) => {
            console.log("result",result)
            if (result.body.returnmsg === "Successful") {
              this.warehouseAdmin = [];
              this.warehouseData = result.body.returnvalue;
              // console.log("oooooooooooooooooooooooooooooooooooooooooooooooo")
              for (let i = 0; i < this.warehouseData.length; i++) {
                // console.log("oooooooooooooooooooooooooooooooooooooooooooooooo")
                let whadmin = {
                  name_wh: this.warehouseData[i].city + ' - ' + this.warehouseData[i].warehousename,
                  id_wh: this.warehouseData[i].warehouseid,
                };
                this.warehouseAdmin.push(whadmin);
                // console.log("warehouseAdmin",this.warehouseAdmin)
              }
            }
          })
          .catch((ex) => {
            console.log("error", ex);
          });
        } 
        else{
          this.warehouseData = [];
          this.warehouseAdmin = [];
          this.valueWHAdmin = [];
        }
      },
  
      selectWHAdmin: function() {
          var systemUserid = [];
          this.valueWHAdmin;
          this.valueWHAdmin.toString();
      },
  
      validateForm(scope) {
        this.$validator.validateAll(scope).then((result) => {
          if (result) {
            this.changeVehicleCityWH();
          }
        });
      },
  
      changeVehicleCityWH: function() {
        document.getElementById("overlayModal").style.display = "block";
        let userData = localStorage.getItem("userData");
        let userInfo = JSON.parse(userData);
        let obj = {
          vehicleid: this.vehicle_Id,
          sysusermasterid: this.valueAdmin,
          lastmodifiedby:
            `${userInfo.userfirstname}` + " " + `${userInfo.userlastname}`,
            warehouseid : this.valueWHAdmin,
          // sysusermasterid:`${userInfo.sysusermasterid}`,
          // usertype:`${userInfo.user_type}`,
        };
        console.log("OOOOOO", obj);
        // return false;
        this.$http
          .post(
            `${CONSTANTS.MISREPORT_API_URL}/updateCityAndWarehouseForVehicle`,
            obj
          )
          .then((result) => {
            console.log(result.body);
            // this.isBusy = false;
            document.getElementById("overlayModal").style.display = "none";
            if (result.body.returnmsg === "Successful") {
              this.$fire({
                text: "Admin Updated Successfully",
                type: "success",
                timer: 30000,
              });
              this.displaydata();
              this.vehicleCityWHmodal = false;
            } else {
              this.$fire({
                text: result.body.returnmsg,
                type: "warning",
                timer: 30000,
              });
              // this.editCity=false;
            }
          })
          .catch((ex) => {
            console.log("error", ex);
          });
      },
  
      editCityWHcancel: function(value) {
        // console.log("Value",value);
        this.vehicleCityWHmodal = false;
      },
  
      isJson: function(str) {
        try {
          JSON.parse(str);
        } catch (e) {
          return false;
        }
        return true;
      },
  
      editAgentMasterModal: function(value) {
        this.customer.deliveryagentpassword = value.deliveryagentpassword;
        this.customer.deliveryagentmasterid = value.deliveryagentmasterid;
        this.editAgentMastertoggleInfo = !this.editAgentMastertoggleInfo;
      },
  
      toggleInfoModal: function(value) {
        this.customer = value;
  
        this.toggleInfo = !this.toggleInfo;
      },
  
      activateInActivateDeliveryAgent: function(value) {
        var activeInactiveVal;
        if (this.customer.isactive === "1") {
          activeInactiveVal = "0";
          // console.log("activeInactiveVal",activeInactiveVal);
        } else {
          activeInactiveVal = "1";
          // console.log("activeInactiveVal1",activeInactiveVal);
        }
        var userdata = localStorage.getItem("userData");
        var userInfo = JSON.parse(userdata);
        const customerGetobj = {
          // deliveryagentmasterid: deliveryagentmasterId,
          vehicleMasterid: this.customer.vehicle_id,
          isactive: activeInactiveVal,
          lastmodifiedby:
            `${userInfo.userfirstname}` + " " + `${userInfo.userlastname}`,
        };
        console.log("JJJJJJJJ", customerGetobj);
        // return false;
        this.$http
          .post(
            `${CONSTANTS.MIGRATION_API_URL}/activateinactivatedeliveryagent`,
            customerGetobj
          )
          .then((result) => {
            console.log("result", result);
            if (result.body.returnmsg === "Successfull") {
              // alert("Shipments are Allocated so can not InActive");
              this.$fire({
                text: "Status Changed Successfully",
                type: "success",
                timer: 30000,
              });
  
              this.toggleInfo = false;
              this.displaydata();
            } else {
              this.$fire({
                text: result.body.returnvalue,
                type: "error",
                timer: 30000,
              });
              this.toggleInfo = false;
            }
          })
          .catch((ex) => {
            console.log("error", ex);
          });
        //  this.displaydata();
        // alert("Status changed successfully");
      },
  
      changePassword(value) {
        this.vehicle_id = "";
        // alert("innnn");
        // console.log("Value",value);
        this.vehicle_id = value.vehicle_id;
  
        this.resetPassword = true;
      },
  
      cancelPassword() {
        this.sysusermasterid = "";
        this.customer = {};
        this.resetPassword = false;
      },
  
      changevehiclestatus(value){
        console.log(value)
  
        this.avilablevehicle = value.is_available;
        console.log("this.avilablevehicle",this.avilablevehicle)
        var activeInactiveVal;
        if (value.is_available == "No") {
          activeInactiveVal = "yes";
        } else {
          activeInactiveVal = "No";
        }
        var userdata = localStorage.getItem("userData");
        var userInfo = JSON.parse(userdata);
        const customerGetobj = {
          vehicle_id: value.vehicle_id,
          is_available: activeInactiveVal,
        };
        console.log("JJJJJJJJ", customerGetobj);
        // return false;
        this.$http
          .post(
            `${CONSTANTS.MIGRATION_API_URL}/makeVehicleAvailable`,
            customerGetobj
          )
          .then((result) => {
            console.log("result", result);
            if (result.body.returnmsg === "Successful") {
              this.$fire({
                text: "Status Changed Successfully",
                type: "success",
                timer: 30000,
              });
  
              this.displaydata();
            } else {
              this.$fire({
                text: result.body.returnvalue,
                type: "error",
                timer: 30000,
              });
            }
          })
          .catch((ex) => {
            console.log("error", ex);
          });
    
      },
  
      availablevehiclelist(){
        this.availablevehiclemodel = !this.availablevehiclemodel
        this.isBusyvlist = true;
        var userdata = localStorage.getItem("userData");
        var userInfo = JSON.parse(userdata);
  
        const obj = {};
  
        // return false;
        this.$http
          .post(
            `${CONSTANTS.MIGRATION_API_URL}/getAvailableVehicle`,
            obj
          )
          .then((result) => {
            console.log("result", result);
            this.isBusyvlist = false;
            if (result.body.returnmsg === "Successful") {
              this.available_vehiclelist = result.body.returnvalue;
              console.log("@@@@@@@", this.available_vehiclelist)
  
              this.totalvehiclelist = result.body.returnvalue.length;
              console.log(this.totalvehiclelist)
            } else {
              this.available_vehiclelist = [];
              this.totalvehiclelist = 0;
            }
          })
          .catch((ex) => {
            console.log("error", ex);
          });
      },
  
      checkGSTlength(value){
        if (value.length>0) {
            this.showverifybutton=true;
            document.getElementById("submitButton").disabled = true; 
          }
        else{
          this.showverifybutton=false;
          this.customer.transporter_gstnumber='';
          this.errors_GST = false;
          this.errors_showGST= {};
          document.getElementById("submitButton").disabled = false;
          this.removeGST=false;
        }
      },
  
      verifyGSTNo(){
        document.getElementById("overlayModal").style.display = "block";
        const infoObj = {
          Gstin:this.customer.transporter_gstnumber.trim(),
        };
        console.log("infoObj",infoObj);
        this.$http.post(`${CONSTANTS.MIGRATION_API_URL}/validateGSTNO`, infoObj).then((result)=>{
          console.log("result",result)
          document.getElementById("overlayModal").style.display = "none";
          if (result.body === "success") {
            document.getElementById("submitButton").disabled = false;
            this.showverifybutton=false;
            this.$fire({
              text: 'Successful Verify',
              type: "success",
              timer: 30000,
            });
            this.errors_GST = false;
            this.errors_showGST.transporter_gstnumber=''
            this.removeGST=false;
          } else {
            this.errors_GST = true;
            this.errors_showGST.transporter_gstnumber = 'Please Enter Valid Transporter Tin Number / GST Number';
            this.removeGST=true;
          }
        }).catch((ex) => {
          console.log("error", ex);
        });
        // if (this.customer.transporter_gstnumber) {
        //     this.errors_GST = true;
        //     this.errors_showGST.transporter_gstnumber = 'Please Enter Valid Transporter Tin Number / GST Number';
        //     this.removeGST=true;
        //     return false;
        // }
        // else{
        //   this.showverifybutton=false;
        //   document.getElementById("submitButton").disabled = false;
        // }
      },
  
      removevalue(){
        this.showverifybutton=false;
        this.customer.transporter_gstnumber='';
        this.errors_GST = false;
        this.errors_showGST= {};
        document.getElementById("submitButton").disabled = false;
        this.removeGST=false;
      },
  
      EmailListing(){
            var userdata = localStorage.getItem("userData");
            var userInfo = JSON.parse(userdata);
  
            let obj = { 
              status:'Approved',
              isactive : '1'
            }
  
            this.$http.post(`${CONSTANTS.MISREPORT_API_URL}/getTransporterEmailIdListNew`,obj)
            .then(result => {
                if(result.body.returnmsg === "Successful"){
                this.mailitems  = result.body.returnvalue;
                console.log("mailitems",this.mailitems);
                var data = [];
    
                this.mailitems.forEach(function (srData) {
                    data.push({
                    key:srData.transporter_id,
                    label:srData.transporter_company_name
                    });
                });
                this.optionmailid = data;
  
                }
                else{
                  this.mailitems=[];
                  this.optionmailid = [];
                }
  
            }).catch(ex => {
              console.log('error', ex)
            })
      },
      
      updateTextbox() {
              let transporterObj={};
              if(this.transporterCompanyName!=null){
                  for(let i=0;i<this.mailitems.length;i++){
                  if(this.transporterCompanyName.key===this.mailitems[i].transporter_id){
                      transporterObj={
                          transporter_id:this.mailitems[i].transporter_id,
                          transporter_name:this.mailitems[i].transporter_name,
                          transporter_emailid:this.mailitems[i].transporter_emailid,
                          transporter_mobilenumber:this.mailitems[i].transporter_mobilenumber,
                          // transporter_gstnumber:this.mailitems[i].transporter_gst_no
                          transporter_gstnumber:this.mailitems[i].transporter_gst_no == undefined || this.mailitems[i].transporter_gst_no == 'undefined' ? '' : this.mailitems[i].transporter_gst_no
                      }
                  }
              }
              this.transporterObj=transporterObj;
              console.log("this.transporterObj",this.transporterObj);
              this.updateData(transporterObj);
              }
      },
      
      updateData(transporterObj){
        // this.transporterCompanyName=
        this.customer.contracter_emailid=transporterObj.transporter_emailid;
        this.customer.driver_contracter_name=transporterObj.transporter_name;
        this.customer.contractormobilenumber=transporterObj.transporter_mobilenumber;
        this.customer.transporter_gstnumber=transporterObj.transporter_gstnumber;
              
      },

      updateModal(data){
        console.log(data, 'dataataatataat');
        this.addInfoCard = false
        console.log("data11111",data);
        this.updatetFreightVehicleObj={};
        this.updatetFreightVehicleObj.transporter_id=data.transporter_id
        this.updatetFreightVehicleObj.vehicle_no =data.vehicle_no
        this.updatetFreightVehicleObj.transporter_name =data.transporter_name
        this.updatetFreightVehicleObj.vehicle_permit =data.vehicle_permit_of_vehicle
        this.updatetFreightVehicleObj.vehicleweightcarrying =data.vehicleweightcarrying
        this.updatetFreightVehicleObj.drivermobilenumber =data.drivermobilenumber
        this.updatetFreightVehicleObj.vehicle_id =data.vehicle_id
        this.updatetFreightVehicleObj.no_of_levels =data.no_of_levels
        this.updatetFreightVehicleObj.nextreviewer =data.nextreviewer
        this.updatetFreightVehicleObj.labour_charges =data.labour_charges
        this.updatetFreightVehicleObj.fixed_kms =data.fixed_kms
        this.updatetFreightVehicleObj.fixed_freightrate =data.fixed_freightrate
        this.updatetFreightVehicleObj.extra_kmrate =data.extra_kmrate
        this.updatedFreight_workingdays =data.workingdays
        // this.updatetFreightVehicleObj.workingdays1 =data.workingdays
        // this.updatetFreightVehicleObj.paymenttype = data.paymenttype
        this.updatedFreight_paymenttype = data.paymenttype
        this.freightUpdateWorkingDays(this.updatedFreight_paymenttype)
        this.calculateFreightCost();

        this.updateInfo = !this.updateInfo;    
      },

      RejectModal(data) {
        console.log(data, 'datatttt')
        this.addInfoCard = false
        this.updatetFreightVehicleObj={};
        this.updatetFreightVehicleObj.transporter_id=data.transporter_id
        this.updatetFreightVehicleObj.vehicle_no =data.vehicle_no
        this.updatetFreightVehicleObj.transporter_name =data.transporter_name
        this.updatetFreightVehicleObj.vehicle_permit =data.vehicle_permit_of_vehicle
        this.updatetFreightVehicleObj.vehicleweightcarrying =data.vehicleweightcarrying
        this.updatetFreightVehicleObj.drivermobilenumber =data.drivermobilenumber
        this.updatetFreightVehicleObj.vehicle_id =data.vehicle_id,
        this.updatetFreightVehicleObj.transporter_emailid= data.transporter_emailid,
        this.updatetFreightVehicleObj.transporter_mobilenumber= data.transporter_mobilenumber,
        this.updatetFreightVehicleObj.transporter_company_name= data.transporter_company_name,
         this.updatetFreightVehicleObj.vehicle_id =data.vehicle_id
        this.updatetFreightVehicleObj.no_of_levels =data.no_of_levels
        this.updatetFreightVehicleObj.nextreviewer =data.nextreviewer
        this.updatetFreightVehicleObj.labour_charges =data.labour_charges
        this.updatetFreightVehicleObj.fixed_kms =data.fixed_kms
        this.updatetFreightVehicleObj.fixed_freightrate =data.fixed_freightrate
        this.updatetFreightVehicleObj.extra_kmrate =data.extra_kmrate
        this.updatedFreight_workingdays =data.workingdays
        // this.updatetFreightVehicleObj.workingdays1 =data.workingdays

        this.rejectInfo = !this.rejectInfo;
      },

      editFreightApprovalandRejectForm(scope,reason){
        this.$validator.validateAll(scope).then((result) => {
        if (result) {
            // this.editTransporterInfo();
            this.PendingIncidentBtn(this.updatetFreightVehicleObj, reason)
        }
        });
      },

    
      closePendingIncidentModal(close) {
        this.updatetFreightVehicleObj={};
        if (close === 'rejectIncident') {
          this.rejectInfo = false;
        }
        if (close === 'approveIncident') {
          this.updateInfo = false;
        }
      },

      PendingIncidentBtn(updatetFreightVehicleObj, reason) {
        if (reason === 'rejectIncident') {
            this.loader=true;
          let userdata = localStorage.getItem("userData");
          let userInfo = JSON.parse(userdata);
              const infoObj = {
                  reject_reason: this.updatetFreightVehicleObj.rejectReason,
                  vehicle_id:this.updatetFreightVehicleObj.vehicle_id, 
                  no_of_levels:this.updatetFreightVehicleObj.no_of_levels, 
                  nextreviewer:this.updatetFreightVehicleObj.nextreviewer, 
                  user_approval_level:this.updatetFreightVehicleObj.nextreviewer,
                  lastmodifiedby:`${userInfo.sysemailid}`,     
              };
              console.log("infoObj",infoObj);
              // return false;
          this.$http.post(`${CONSTANTS.MIGRATION_API_URL}/rejectFreightPendingVehicle`, infoObj).then((result)=>{
            this.loader=false;
            if (result.body.returnmsg === "Successful") {
              this.$fire({
                text: result.body.returnvalue,
                type: "success",
                timer: 30000,
              });
             this.closePendingIncidentModal(reason);
              this.displaydata();
            } else {
              this.$fire({
                text: result.body.returnvalue,
                type: "error",
                timer: 30000,
              });
            }
          }).catch((ex) => {
            console.log("error", ex);
          });
        }

        if (reason === 'approveIncident') {
          this.loader=true;
          let userdata = localStorage.getItem("userData");
          let userInfo = JSON.parse(userdata);
              const infoObj = {
                  vehicle_id:this.updatetFreightVehicleObj.vehicle_id, 
                  no_of_levels:this.updatetFreightVehicleObj.no_of_levels, 
                  nextreviewer:this.updatetFreightVehicleObj.nextreviewer, 
                  labour_charges:this.updatetFreightVehicleObj.labour_charges, 
                  fixed_kms:this.updatetFreightVehicleObj.fixed_kms, 
                  fixed_freightrate:this.updatetFreightVehicleObj.fixed_freightrate, 
                  extra_kmrate:this.updatetFreightVehicleObj.extra_kmrate, 
                  workingdays:this.updatedFreight_workingdays, 
                  user_approval_level:this.updatetFreightVehicleObj.nextreviewer,
                  payment_mode:this.updatedFreight_paymenttype,
                  lastmodifiedby:`${userInfo.sysemailid}`,               
              };

              console.log("infoObj",infoObj);
             // return false;
          this.$http.post(`${CONSTANTS.MIGRATION_API_URL}/approveFreightPendingVehicle`, infoObj).then((result)=>{
            this.loader=false;
            if (result.body.returnmsg === "Successful") {
              
              this.$fire({
                text: result.body.returnvalue,
                type: "success",
                timer: 30000,
              });
             
             this.closePendingIncidentModal(reason);              
             this.displaydata();

            } else {
              this.$fire({
                text: result.body.returnvalue,
                type: "error",
                timer: 30000,
              });
            }
          }).catch((ex) => {
            console.log("error", ex);
          });
        }
        
      },

      editinfoModal: function(value) {
        console.log('value===================',value);
        
         this.adminWiseHubList(value.hubid);
        // console.log("value",value)
        // if(value.hubid){
        // console.log(' this.hubList.', this.optionHubid)
        //   this.adminHub=value.hubid;
        // // }
       
        // this.selected_type = value.vehicle_type;
        this.vehiclenametext=false;
        this.vehicletypesizetext=false;
        this.errors_GST =false;
        this.errors_showGST={};
        this.removeGST=false;
        this.showverifybutton = false;
        this.customer ={}
        this.errors_showGST.transporter_gstnumber = '';
        this.EmailListing();
        this.helper_data=[];
        this.customer.driverfirstname = value.driverfirstname;
        this.customer.driverlastname = value.driverlastname;
        this.customer.drivermobilenumber = value.drivermobilenumber;
        // this.customer.vehicleno_prefix = value.vehicleno_prefix;
        // this.customer.vehiclename = value.vehicle_name;
       
        for (let i = 0; i < this.vehicleNameOptions.length; ++i) {
          if (value.vehiclename_id == this.vehicleNameOptions[i].key) {
            this.customer.vehiclename = this.vehicleNameOptions[i].label;
          }
        }
        this.vehicleName_id = value.vehiclename_id
        this.customer.vehicletype = value.vehicle_type;
        for(let i=0;i<this.fuelTypeOptions.length;++i){
              if(value.fueltype_id == this.fuelTypeOptions[i].key){
                this.customer.fueltype =  this.fuelTypeOptions[i].label;
              }
          }
          for(let i=0;i<this.vehicleTypeSizeOptions.length;++i){
            if(value.vehicletype_size_id == this.vehicleTypeSizeOptions[i].key){
              this.customer.vehicletypesize=this.vehicleTypeSizeOptions[i].label;
              }
        }
        
        // this.customer.fueltype = value.fueltype_id;
        this.fuelType_id = value.fueltype_id;
       // this.customer.vehicletypesize = value.vehicletype_size_id
        this.vehicleTypeSize_id = value.vehicletype_size_id;
        this.customer.registration_no = value.registration_no;
        //this.customer.vehiclemake = value.vehicle_make;
        this.customer.vehicleweightcarrying = value.vehicleweightcarrying;
        this.customer.vehiclephysicalweight = value.vehiclephysicalweight;
        // this.customer.vehicledimensionsweight = value.vehicledimensionsweight
        this.customer.editvehicleno = value.vehicle_no;
        this.customer.vehicleMasterid = value.vehicle_id;
  
        this.customer.mobile_no = value.drivermobilenumber;
        this.customer.altmobile_no = value.driveraltmobilenumber;
  
        this.customer.helperfirstname = value.helperfirstname;
        this.customer.helperlastname = value.helperlastname;
        this.customer.helpermobilenumber = value.helpermobilenumber;
        this.customer.helperaltmobilenumber = value.helperaltmobilenumber;
        this.customer.contractormobilenumber = value.contractormobilenumber;
        this.customer.pincode = value.pincode  ? value.pincode.toString() : '',

  
        this.customer.driving_license = value.driving_license;
        // if(value.transporter_id!=null){
          // this.customer.driver_contracter_name = value.drivercontractername;
          this.customer.contracter_emailid = value.contracter_emailid || value.transporter_emailid;
          this.customer.transporter_gstnumber = value.transporter_gst_no
          this.transporter_id = value.transporter_id;
          // this.transporterCompanyName= value.drivercontractername != null ? value.transporter_company_name : '';
          if(value.transporter_company_name){
            this.transporterCompanyName = value.transporter_company_name
          }else{
            this.transporterCompanyName= value.drivercontractername 
          }

          if (value.transporter_name) {
            this.customer.driver_contracter_name = value.transporter_name;
          }else{
            this.customer.driver_contracter_name = value.drivercontractername;
          }

          if (value.registered_from) {            
          if (value.registered_from.toLowerCase() == 'transporter_portal') {
            this.customer.bankname = value.bank_name;
            this.customer.branchname = value.branch_code;
            this.customer.bankaccountname = value.account_holder_name;
            this.customer.accountnumber = value.fastag_account_linked;
            this.customer.address = value.address ? value.address : '';
        // }
            this.customer.ifsccode = value.ifsc_pin;
            if (value.vehicle_type == 'adhoc') {
              this.customer.pan =  '',
              this.customer.aadhar = '';
            }else{
              this.customer.pan = value.pan ? value.pan : '';
              this.customer.aadhar = value.aadhar? value.aadhar : '';
            }
          }else{
            this.customer.bankname = value.bankname ? value.bankname : '';
            this.customer.bankaccountname = value.bankaccountname ? value.bankaccountname : '';
            this.customer.branchname = value.branchname ? value.branchname  : '';
            this.customer.accountnumber = value.accountnumber ? value.accountnumber : '';
            this.customer.ifsccode = value.ifsccode ? value.ifsccode : '';
            this.customer.aadhar = value.aadhar? value.aadhar : '';
            this.customer.address = value.address ? value.address : '';
            this.customer.pan = value.pan ? value.pan : ''
          }
        }else{
            this.customer.bankname = value.bankname ? value.bankname : '';
            this.customer.bankaccountname = value.bankaccountname ? value.bankaccountname : '';
            this.customer.branchname = value.branchname ? value.branchname  : '';
            this.customer.accountnumber = value.accountnumber ? value.accountnumber : '';
            this.customer.ifsccode = value.ifsccode ? value.ifsccode : '';
            this.customer.aadhar = value.aadhar? value.aadhar : '';
            this.customer.address = value.address ? value.address : '';
           this.customer.pan = value.pan ? value.pan : ''
        // }
          }
 
           // console.log("this.transporter_id ",this.transporter_id )
          this.customer.address = value.address ? value.address : '',
          // this.customer.city = value.city ? value.city : '',
          // this.customer.state = value.state ? value.state : '',
          // this.customer.bankname = value.bankname ? value.bankname : '',
          // this.customer.bankaccountname = value.bankaccountname ? value.bankaccountname : '',
          // this.customer.branchname = value.branchname ? value.branchname  : '',
          // this.customer.accountnumber = value.accountnumber ? value.accountnumber : '',
          // this.customer.ifsccode = value.ifsccode ? value.ifsccode : '',
          this.customer.vendortype = value.vendortype ? value.vendortype.toLowerCase() : '';
          if (value.vendortype == 'Owned') {
            this.customer.vendortype = 'normal'

          }
          this.customer.promotername = value.promotername ? value.promotername : '',

          // this.customer.gstinnumber = value.gstinnumber ? value.gstinnumber : '',
          this.customer.bankcancelledcheque= value.bankcancelledcheque ? value.bankcancelledcheque : '',

          this.customer.gstincertificate= value.gstincertificate ? value.gstincertificate : '',          
          this.customer.registration_url= value.registration_url ? value.registration_url: '',
          this.customer.puc_url = value.puc_url? value.puc_url: '',
          this.customer.pucnumberfile =   value.puc_url? value.puc_url.split('?key=')[1].split('-').pop(): '';          

          this.customer.insurance_url = value.insurance_url ? value.insurance_url : '',
          this.customer.permit_url = value.permit_url ? value.permit_url : '',
          this.customer.paymenttype = value.paymenttype ? value.paymenttype : '',
          this.customer.licence_url = value.licence_url ? value.licence_url : '',
          this.customer.labour_charges = value.labour_charges ? value.labour_charges : '',
          this.customer.fixed_kms = value.fixed_kms ? value.fixed_kms : '',
          this.customer.fixed_freightrate = value.fixed_freightrate ? value.fixed_freightrate : '',
          this.customer.extra_kmrate= value.extra_kmrate ? value.extra_kmrate : '';
          if (this.customer.paymenttype.toLowerCase() == 'monthly') {
            this.customer.workingdays = 31

          }else if(this.customer.paymenttype.toLowerCase() == 'weekly'){
            this.customer.workingdays = 7

          }else{
            this.customer.workingdays = 1
          }
          if(this.customer.pincode){    
            this.pincodeChange(this.customer.pincode) 
          }
        
        
         
        // console.log("this.transporter_id ",this.transporter_id )
       this.calculateFreightCostEdit();
        this.editAgentMaster = !this.editAgentMaster;
      },

      getPincodeList:function(){
            var userdata = localStorage.getItem("userData");
            var userInfo = JSON.parse(userdata);

            const Obj={}
            this.$http.post(`${CONSTANTS.MIGRATION_API_URL}/getPincode`, Obj)
            .then((result)=>{
                if(result.body && result.body.returnmsg== "Successful"){
                    this.pincodeCityData = result.body.returnvalue;                    
                    for(let i=0;i<this.pincodeCityData.length;++i){
                        this.pincodes.push({
                            key:this.pincodeCityData[i].pincode,
                            label:this.pincodeCityData[i].pincode
                        })
                    }
                    console.log("pincodes-->",this.pincodes) 
                }
                else{
                    this.pincodes=[];
                }
            })
            .catch((ex) => {
                console.log("error", ex);
            });
        },

      selectBankChequeFile(event){
            this.selectedBankCheque= event.target.files[0];            
            if (this.selectedBankCheque) {
                this.bankFileName = `${event.target.files[0].name}`; 
            }
            this.bankFileType = this.selectedBankCheque.type;
            this.uploadBankCheque(this.selectedBankCheque);
        },

        uploadBankCheque : function () {
          document.getElementById("overlayModal").style.display = "block";
         var userData = localStorage.getItem('userData');
         var userInfo = JSON.parse(userData);

            let data = new FormData();
            data.append('file', this.selectedBankCheque)
            axios.post(`${CONSTANTS.MIGRATION_API_URL}/uploadfiletos3`,data, 
                {
                    header : { 'Content-Type' : 'multipart/form-data'
                    }, 
                })
            .then(response => {
              document.getElementById("overlayModal").style.display = "none";
                if (response.data.result=='success') {
                    this.$fire({
                        text:"File Uploaded",
                        type: "success",
                        timer: 300000
                    })
                    this.bankcancelledcheque=response.data.image_url;  
                    this.customer.bankcancelledcheque=response.data.image_url;     
                } else {
                    this.$fire({
                        text:"File Not Uploaded",
                        type: "error",
                        timer: 300000
                    })
                }
            })
            .catch(e => {
                console.log('Error In Upload Bank check',e);
                
            })
        
        },

        selectGstinCertficateFile(event){
            this.selectedGstinCertficate= event.target.files[0];            
            if (this.selectedGstinCertficate) {
                this.gstinCertficateFilename = `${event.target.files[0].name}`; 
            }
            this.gstinCertficateType = this.selectedGstinCertficate.type;
            this.uploadGstin(this.selectedGstinCertficate);

        },

        uploadGstin : function () {
          document.getElementById("overlayModal").style.display = "block";

        var userData = localStorage.getItem('userData');
        var userInfo = JSON.parse(userData);

            let data = new FormData();
            data.append('file', this.selectedGstinCertficate)
            axios.post(`${CONSTANTS.MIGRATION_API_URL}/uploadfiletos3`,data, 
                {
                    header : { 'Content-Type' : 'multipart/form-data'
                    }, 
                })
            .then(response => {
              document.getElementById("overlayModal").style.display = "none";

                if (response.data.result=='success') {
                    this.$fire({
                        text:"File Uploaded",
                        type: "success",
                        timer: 300000
                    })
                    this.gstincertificate=response.data.image_url;   
                    this.customer.gstincertificate=response.data.image_url;          
                } else {
                    this.$fire({
                        text:"File Not Uploaded",
                        type: "error",
                        timer: 300000
                    })
                }
            })
            .catch(e => {
                console.log('Error in upload GSTIN certificate',e);
                
            })
        
        },

      pincodeChange(data) {  
        let pincode = ''
        if(data){
          if(!data.label){
          pincode = data
          }else{
            pincode = data.label
          }      
            this.$set(this.customer, 'city', '');
            this.$set(this.customer, 'state', '');
            if (pincode) {
              const selectedPincode = this.pincodeCityData.find(
                  item => item.vendorpincode == pincode
              );

                if (selectedPincode) {
                    this.$set(this.customer, 'city', selectedPincode.vendorcity);
                    this.$set(this.customer, 'state', selectedPincode.vendorstate);
                }
            }
         }
        },
        downloadFile(fileUrl) {
          
          // Open the file URL in a new tab
          if (fileUrl) {
              window.open(fileUrl, '_blank');
          } else {
            this.$fire('No file available for download!', {
                  title: 'Error',
                  variant: 'danger',
                  solid: true,
              });
          }
      },
      driverLicenseFileUplod(event) {
        this.selectedDl = event.target.files[0];
        if (this.selectedDl) {
          this.dlFileName = `${event.target.files[0].name}`;
        }
        this.dlFileType = this.selectedDl.type;
        this.uploadDL(this.selectedDl);
      },
      uploadDL: function() {
        document.getElementById("overlayModal").style.display = "block";

        var userData = localStorage.getItem('userData');
        var userInfo = JSON.parse(userData);
        let data = new FormData();
        data.append('file', this.selectedDl)
        axios.post(`${CONSTANTS.MIGRATION_API_URL}/uploadfiletos3`, data, {
          header: {
            'Content-Type': 'multipart/form-data'
          },
        }).then(response => {
          document.getElementById("overlayModal").style.display = "none";

          if (response.data.result == 'success') {
            this.$fire({
              text: "File Uploaded",
              type: "success",
              timer: 300000
            })
            this.licence_url = response.data.image_url;
            this.customer.licence_url = response.data.image_url;

          } else {
            this.$fire({
              text: "File Not Uploaded",
              type: "error",
              timer: 300000
            })
          }
        }).catch(e => {
          console.log('Error In licence check', e);
        })
      },
      pucFileUplod1(event) {
        this.pucFileUplod = event.target.files[0];
        if (this.pucFileUplod) {
          this.pucFileUplodFilename = `${event.target.files[0].name}`;
        }
        this.pucFileUplodType = this.pucFileUplod.type;
        this.uploadPuc(this.pucFileUplod);
      },
      uploadPuc: function() {
        document.getElementById("overlayModal").style.display = "block";

        var userData = localStorage.getItem('userData');
        var userInfo = JSON.parse(userData);
        let data = new FormData();
        data.append('file', this.pucFileUplod)
        axios.post(`${CONSTANTS.MIGRATION_API_URL}/uploadfiletos3`, data, {
          header: {
            'Content-Type': 'multipart/form-data'
          },
        }).then(response => {
          document.getElementById("overlayModal").style.display = "none";

          if (response.data.result == 'success') {
            this.$fire({
              text: "File Uploaded",
              type: "success",
              timer: 300000
            })
            this.puc_url = response.data.image_url;
            this.customer.puc_url=response.data.image_url;
          } else {
            this.$fire({
              text: "File Not Uploaded",
              type: "error",
              timer: 300000
            })
          }
        }).catch(e => {
          console.log('Error In Upload Bank check', e);
        })
      },
      registrationFileUplod(event) {
        this.selectedRegistration = event.target.files[0];
        if (this.selectedRegistration) {
          this.registrationFilename = `${event.target.files[0].name}`;
        }
        this.registrationFileType = this.selectedRegistration.type;
        this.uploadRegisterFile(this.selectedRegistration);
      },
      uploadRegisterFile: function() {
        document.getElementById("overlayModal").style.display = "block";

        var userData = localStorage.getItem('userData');
        var userInfo = JSON.parse(userData);
        let data = new FormData();
        data.append('file', this.selectedRegistration)
        axios.post(`${CONSTANTS.MIGRATION_API_URL}/uploadfiletos3`, data, {
          header: {
            'Content-Type': 'multipart/form-data'
          },
        }).then(response => {
          document.getElementById("overlayModal").style.display = "none";

          if (response.data.result == 'success') {
            this.$fire({
              text: "File Uploaded",
              type: "success",
              timer: 300000
            })
            this.registration_url = response.data.image_url;
            this.customer.registration_url=response.data.image_url;

          } else {
            this.$fire({
              text: "File Not Uploaded",
              type: "error",
              timer: 300000
            })
          }
        }).catch(e => {
          console.log('Error in upload register certificate', e);
        })
      },
      insuranceFileUplod(event) {
        this.selectedInsuranceFile = event.target.files[0];
        if (this.selectedInsuranceFile) {
          this.registrationFilename = `${event.target.files[0].name}`;
        }
        this.registrationFileType = this.selectedInsuranceFile.type;
        this.uploadInsuranceFile(this.selectedInsuranceFile);
      },
      uploadInsuranceFile: function() {
        document.getElementById("overlayModal").style.display = "block";

        var userData = localStorage.getItem('userData');
        var userInfo = JSON.parse(userData);
        let data = new FormData();
        data.append('file', this.selectedInsuranceFile)
        axios.post(`${CONSTANTS.MIGRATION_API_URL}/uploadfiletos3`, data, {
          header: {
            'Content-Type': 'multipart/form-data'
          },
        }).then(response => {
          document.getElementById("overlayModal").style.display = "none";

          if (response.data.result == 'success') {
            this.$fire({
              text: "File Uploaded",
              type: "success",
              timer: 300000
            })
            this.insurance_url = response.data.image_url;
            this.customer.insurance_url = response.data.image_url;
          } else {
            this.$fire({
              text: "File Not Uploaded",
              type: "error",
              timer: 300000
            })
          }
        }).catch(e => {
          console.log('Error in upload register certificate', e);
        })
      },
      permitFileUplod(event) {
        this.selectedPermit = event.target.files[0];
        if (this.selectedPermit) {
          this.permitFileName = `${event.target.files[0].name}`;
        }
        this.permitFileType = this.selectedPermit.type;
        this.uploadPermitFile(this.selectedPermit);
      },
      uploadPermitFile: function() {
        document.getElementById("overlayModal").style.display = "block";

        var userData = localStorage.getItem('userData');
        var userInfo = JSON.parse(userData);
        let data = new FormData();
        data.append('file', this.selectedPermit)
        axios.post(`${CONSTANTS.MIGRATION_API_URL}/uploadfiletos3`, data, {
          header: {
            'Content-Type': 'multipart/form-data'
          },
        }).then(response => {
          document.getElementById("overlayModal").style.display = "none";

          if (response.data.result == 'success') {
            this.$fire({
              text: "File Uploaded",
              type: "success",
              timer: 300000
            })
            this.permit_url = response.data.image_url;
            this.customer.permit_url = response.data.image_url;

          } else {
            this.$fire({
              text: "File Not Uploaded",
              type: "error",
              timer: 300000
            })
          }
        }).catch(e => {
          console.log('Error In Upload Permit File', e);
        })
      }

    },
  
    filters: {
      datechange: function(value) {
        if (value == null) {
          return "-";
        } else {
          var d = new Date(value);
          var curr_date = (d.getDate() < 10 ? "0" : "") + d.getDate();
          var month = d.getMonth() + 1;
          var curr_year = d.getFullYear();
          var curr_month = month < 10 ? "0" + month : "" + month;
          var hours = d.getHours();
          var minutes = d.getMinutes();
          var ampm = hours >= 12 ? "pm" : "am";
          hours = hours % 12;
          hours = hours ? hours : 12; // the hour '0' should be '12'
          minutes = minutes < 10 ? "0" + minutes : minutes;
          var strTime = hours + ":" + minutes + " " + ampm;
          return (
            curr_date + "-" + curr_month + "-" + curr_year + "  " + " " + strTime
          );
        }
      },
     
      capitalize: function(value) {
        if (!value) return "";
        value = value.toString();
        return value.charAt(0).toUpperCase() + value.slice(1);
      },
    },
  };
  </script>
  
  <style scoped>
   .custom-open-modal {
    background-color: #C0EA47 !important;
  }
  
  .custom-close-modal {
    background-color: #EF7979 !important;
    margin-left: 5px !important;
  }
  .custom-border label{
    overflow: hidden !important;
    line-height: 22px !important;
}
  /*.volume{
    width: 55px !important;
  }*/
  /*.physicalweight{
    width: 80px;
  }*/
  /*.swal2-header {
      display: flex;
      flex-direction: column;
      align-items: center;
      font-size: 10px;
  }*/
  </style>
 